<template>
  <div :class="['main',{ 'use-in-basket' : addCart.totalPrice > 0}]"
       @scroll="scrollFunction"
       ref="main"
       @touchstart="backgroundTochStart($event)">
    <!-- 알림톡 진입시 -->
    <div v-if="kakao"
         class="kakao-page">
      <div class="store-head kakao-head">
        <img :src="storeInfo.STORE_LOGO"
             class="storeImg kakao-logo">
      </div>
      <div class="store-title">
        <div>{{storeInfo.STORE_NAME}}</div>
        <div v-if="eventFlag === 1 &&
          $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
          $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
          $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
          $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
          $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015'"
             @click="removeKakao">할인품목 {{eventList.length}}개</div>
        <div v-else-if="eventFlag === 2 &&
          $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
          $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
          $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
          $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
          $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015'"
             @click="removeKakao">할인예정품목 {{eventList.length}}개</div>
      </div>
      <div v-if="eventFlag !== 0"
           class="kakao-title"
           @click="removeKakao">
        <img src="@/assets/icon/new_bridge.gif" />
        <span>{{ eventTitle }}</span>
      </div>
      <div class="kakao-icon">
        <a class="kakao-icon-img"
           :href="`tel: ${mapData.storeTel}`">
          <img src="@/assets/icon/icon_call.png" />
        </a>
        <div class="kakao-icon-bar"></div>
        <div class="kakao-icon-img"
             @click="removeKakao">
          <img src="@/assets/icon/icon_view.png" />
        </div>
        <div v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
        $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
        $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
        $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000950' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000951' && $store.state.storeInfo.STORE_SEQ !== '052_00000152' &&
        $store.state.storeInfo.STORE_SEQ !== '052_00000153' && $store.state.storeInfo.STORE_SEQ !== '031_00000120' &&
        $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
             class="kakao-icon-bar"></div>
        <div v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
        $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
        $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
        $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000950' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000951' && $store.state.storeInfo.STORE_SEQ !== '052_00000152' &&
        $store.state.storeInfo.STORE_SEQ !== '052_00000153' && $store.state.storeInfo.STORE_SEQ !== '031_00000120' &&
        $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
             class="kakao-icon-img"
             @click="moveChat">
          <img src="@/assets/icon/icon_qa.png" />
        </div>
        <div class="kakao-icon-bar"></div>
        <div class="kakao-icon-img"
             @click="shareLink()">
          <img src="@/assets/icon/icon_share2.png" />
        </div>
      </div>
      <div class="kakao-bar"></div>
      <div class="kakao-memo">
        <div><img src="@/assets/icon/icon_location.png" />{{ mapData.storeAddress }}</div>
        <div><img src="@/assets/icon/icon_watch.png" />{{ storeTime }}</div>
        <div><img src="@/assets/icon/icon_phone.png" />{{ mapData.storeTel }}</div>
      </div>
      <div class="kakao-bar"></div>
      <!-- <Map :mapData="mapData"
                          :deliveryTimeValue="deliveryTimeValue" style="height: 300px;" /> -->
      <CompanyAddress :mapData="mapData2"
                      :deliveryTimeValue="deliveryTimeValue"
                      :kakao=true
                      style="height: 440px;" />
      <AppChatBar v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
        $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
        $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
        $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015' && 
        $store.state.storeInfo.STORE_SEQ !== '051_00000950' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000951' && $store.state.storeInfo.STORE_SEQ !== '052_00000152' &&
        $store.state.storeInfo.STORE_SEQ !== '052_00000153' && $store.state.storeInfo.STORE_SEQ !== '031_00000120' &&
        $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
                  :tel="$store.state.storeInfo.STORE_TEL" />
      <div class="kakao-footer"
           @click="removeKakao">
        행사 전단지 보기
      </div>
    </div>
    <!-- 기존 화면 -->
    <div v-else>
      <div class="store-head">
        <img :src="storeInfo.STORE_LOGO"
             class="storeImg">
        <div class="storeHeadContent">
          <span class="storeTitle">{{storeInfo.STORE_NAME}}</span>
          <div class="storeImgDivBot"
               v-if="subTitleFlag === '1' && subTitle !== 'empty'">
            <span class="storeTitle">{{subTitle}}</span>
          </div>
          <div class="storeImgDivBot"
               v-else>
            <span class="storeTitle">{{`${$empty(storeInfo.CNT) ? '0' : storeInfo.CNT} 고객님과 함께합니다.`}}</span>
          </div>
        </div>
      </div>
      <div v-if="$store.state.storeInfo.STORE_SEQ !== '051_00000950' && $store.state.storeInfo.STORE_SEQ !== '051_00000951'"
           style="width: 100%; display: flex; justify-content: center; align-items: center; background: #ff9ed0">
        <carousel :slides="slides"
                  :autoplay="true"
                  :interval="5000" />
      </div>
      <div ref="storeMenu"
           id="storeMenu"
           class="store-menu">
        <div v-if="$store.state.storeInfo.VIEW_TYPE !== '1'"
             class="product-tab__container__wrap flex">
          <div class="product-tab__container"
               v-if="selectCategory === 0">
            <div class="product-tab__contents none-select-btn"
                 style="width: 100%;"
                 @click="allEventList.length > 0 && eventSeqSetting(allEventList[0])">일반상품</div>
          </div>
          <div class="product-tab__container"
               v-else>
            <div class="product-tab__contents none-select-btn"
                 style="width: 100%;"
                 @click="$store.state.prevEventSeq && moveRouterPath($store.state.prevEventSeq)">뒤로</div>
          </div>
          <div v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
            $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
               class="order-list-button__container">
            <div class="order-list-button"
                 @click="moveRouter('orderProcessList')"
                 v-if="Number($store.state.storeInfo.DELIVERY_FLAG) !== 0">&nbsp;주문배송&nbsp;</div>
            <div class="order-list-button"
                 @click="basketModal()"
                 v-else>&nbsp;찜 상품&nbsp;</div>
          </div>
          <div class="search__container">
            <input type="search"
                   :value="searchKeyword"
                   @input="searchChange"
                   @keyup.enter.prevent="searchProduct" />
            <img src="@/assets/btn_search.svg"
                 @click="searchProduct" />
          </div>
        </div>
      </div>
      <div class="category-container"
           v-if="eventProductInfo.length > 0">
        <!-- 카테고리 -->
        <div @click="[$refs.storeMenu.scrollTo({top: 0, behavior: 'smooth'}), selectProductCategory = '']"
             :class="[$empty(selectProductCategory) ? 'red' : 'border']">
          <a href="#storeMenu">전체</a>
        </div>
        <div v-for="(category, index) in eventProductInfo"
             :key="index">
          <div v-if="!$empty(category.eachList) && category.eachList.length > 0"
               :class="[selectProductCategory === category.CATEGORY_SEQ ? 'red' : 'border']">
            <a :href="`#category_${category.CATEGORY_SEQ}`"
               @click="[selectProductCategory = category.CATEGORY_SEQ]">{{category.CATEGORY_NAME}}</a>
          </div>
        </div>
      </div>
      <div v-if="!$empty(shortForm0)">
        <iframe v-if="networkCheck() && shortForm0.android1080.indexOf('youtube') > -1"
                :src=shortForm0.android1080
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                style="height: 60vh;"></iframe>
        <iframe v-else-if="!networkCheck() && shortForm0.android360.indexOf('youtube') > -1"
                :src=shortForm0.android360
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                style="height: 60vh;"></iframe>
        <video v-else-if="networkCheck() && $store.state.device !== 'ios'"
               autoplay
               loop
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm0.android1080"
                  type="video/mp4" />
        </video>
        <video v-else-if="networkCheck() && $store.state.device === 'ios'"
               autoplay
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm0.ios720"
                  type="video/mp4" />
        </video>
        <video v-else-if="!networkCheck() && $store.state.device === 'ios'"
               autoplay
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm0.ios360"
                  type="video/mp4" />
        </video>
        <video v-else
               loop
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm0.android360"
                  type="video/mp4" />
        </video>
      </div>
      <div v-if="!$empty(shortForm1)">
        <iframe v-if="networkCheck() && shortForm1.android1080.indexOf('youtube') > -1"
                :src=shortForm1.android1080
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                style="height: 60vh;"></iframe>
        <iframe v-else-if="!networkCheck() && shortForm1.android360.indexOf('youtube') > -1"
                :src=shortForm1.android360
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                style="height: 60vh;"></iframe>
        <video v-else-if="networkCheck() && $store.state.device !== 'ios'"
               autoplay
               loop
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm1.android1080"
                  type="video/mp4" />
        </video>
        <video v-else-if="networkCheck() && $store.state.device === 'ios'"
               autoplay
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm1.ios720"
                  type="video/mp4" />
        </video>
        <video v-else-if="!networkCheck() && $store.state.device === 'ios'"
               autoplay
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm1.ios360"
                  type="video/mp4" />
        </video>
        <video v-else
               loop
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm1.android360"
                  type="video/mp4" />
        </video>
      </div>
      <div v-if="!$empty(shortForm2)">
        <iframe v-if="networkCheck() && shortForm2.android1080.indexOf('youtube') > -1"
                :src=shortForm2.android1080
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                style="height: 60vh;"></iframe>
        <iframe v-else-if="!networkCheck() && shortForm2.android360.indexOf('youtube') > -1"
                :src=shortForm2.android360
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                style="height: 60vh;"></iframe>
        <video v-else-if="networkCheck() && $store.state.device !== 'ios'"
               autoplay
               loop
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm2.android1080"
                  type="video/mp4" />
        </video>
        <video v-else-if="networkCheck() && $store.state.device === 'ios'"
               autoplay
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm2.ios720"
                  type="video/mp4" />
        </video>
        <video v-else-if="!networkCheck() && $store.state.device === 'ios'"
               autoplay
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm2.ios360"
                  type="video/mp4" />
        </video>
        <video v-else
               loop
               muted
               playsinline
               controls
               disablepictureinpicture
               controlsList="nodownload"
               style="width: 80%;">
          <source :src="shortForm2.android360"
                  type="video/mp4" />
        </video>
      </div>
      <div v-if="!$empty(themeUrl)">
        <img :src="themeUrl"
             style="width: 100%;" />
      </div>
      <div class="image__container"
           v-if="selectCategory < 2">
        <!-- 대표전단 -->
        <!-- 대표이미지 없음 start -->
        <div v-if='popList.length < 3'>
          <div class="image-top__container">
            <div class="image-top__contents"
                 v-for="(image, index) in images.top"
                 :key="index">
              <img :src="image"
                   class="image"
                   alt="">
            </div>
          </div>
          <div class="categoryTextarea"
               v-if="!$empty(eventTitle) && eventTitle.indexOf('상시') < 0">
            <div class="title">{{eventTitle}}</div>
            <div class="date">{{eventDate}}</div>
          </div>
        </div>
        <!-- 대표이미지 없음 end -->
        <!-- 대표이미지 있음 start -->
        <div v-if='popList.length >= 3'>
          <div v-for="(row, index1) in images.top"
               :key="index1"
               style="width: 100%; display: flex; flex-direction: column;">
            <img :src="row + '?w=3000&f=webp&q=1'"
                 style="width: 100%; margin: auto;"
                 v-if="row.indexOf('cloudfront.net') > -1 && deviceOs !== 'iPhone' && !isLowFirefoxVersion" />
            <img :src="row + '?w=3000&f=png&q=1'"
                 style="width: 100%; margin: auto;"
                 v-else-if="row.indexOf('cloudfront.net') > -1 && deviceOs === 'iPhone'" />
            <img :src="row"
                 style="width: 100%; margin: auto;"
                 v-else />
          </div>
          <div class="best-container"
               style='width: 100%; background-size: cover; overflow: hidden;'
               :style="{'height': (((popList.length - 3) * 20) + backgroundHeight + ($innerWidth < 360 ? (popList.length - 3) * 8 : $innerWidth < 500 ? (popList.length - 3) * 4.2 : 0)) + 'vw'}">
            <div class="best-container-center">
              <!-- 행사제목 -->
              <div
                   style="width: 90%; position: absolute; top: 1%; left: 5%; font-size: 25px; font-weight: bold; z-index: 40;">
                <div style="text-align: left;">{{eventTitle}}</div>
              </div>
              <!-- 0번 -->
              <div class="top0">
                <div class="top0_content">
                  <div class="top0_content_top"
                       v-if="!$empty(popList[0][6].badgeInfo) || (!$empty(popList[0][6].badgeList) && popList[0][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[0][6].badgeInfo) && !$empty(popList[0][6].badgeInfo.imageUrl) && ($empty(popList[0][6].badgeList) || popList[0][6].badgeList.length === 0)"
                         :src="`${popList[0][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[0][6].badgeList) && popList[0][6].badgeList.length > 0"
                         :src="popList[0][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[0][6].badgeList) && popList[0][6].badgeList.length > 1"
                         :src="popList[0][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[0][6].badgeList) && popList[0][6].badgeList.length > 2"
                         :src="popList[0][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top0_content_img"
                       :src="'https://product.sery.co.kr/'+popList[0][0]+'.jpg'"
                       v-if="!popList[0][5]" />
                  <img class="top0_content_img"
                       :src="popList[0][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[0][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top0_content_img"
                       :src="popList[0][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[0][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top0_content_img"
                       :src="popList[0][5]"
                       v-else />
                  <div class="top0_content_bottom">
                    <div class="top0_content_bottom_0">
                      <img v-if="Number(popList[0][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top0_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[0][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top0_content_bottom_0_price">
                        {{numberWithCommas(popList[0][7])}}
                      </div>
                      <div v-else-if="Number(popList[0][2]) > 0"
                           class="top0_content_bottom_0_price">{{numberWithCommas(popList[0][2])}}</div>
                      <div v-else-if="Number(popList[0][3]) > 0"
                           class="top0_content_bottom_0_price">{{numberWithCommas(popList[0][3])}}</div>
                      <div class="top0_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[0])"
                           v-if="checkBasketIcon(popList[0])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[0])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[0])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[0])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[0])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top0_content_bottom_name"
                         v-if="popList[0][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[0][1] + ' / ' + popList[0][4]}}</div>
                    <div class="top0_content_bottom_name"
                         v-else>{{popList[0][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 1번 -->
              <div class="top1">
                <div class="top1_content">
                  <div class="top1_content_top"
                       v-if="!$empty(popList[1][6].badgeInfo) || (!$empty(popList[1][6].badgeList) && popList[1][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[1][6].badgeInfo) && !$empty(popList[1][6].badgeInfo.imageUrl) && ($empty(popList[1][6].badgeList) || popList[1][6].badgeList.length === 0)"
                         :src="`${popList[1][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[1][6].badgeList) && popList[1][6].badgeList.length > 0"
                         :src="popList[1][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[1][6].badgeList) && popList[1][6].badgeList.length > 1"
                         :src="popList[1][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[1][6].badgeList) && popList[1][6].badgeList.length > 2"
                         :src="popList[1][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top1_content_img"
                       :src="'https://product.sery.co.kr/'+popList[1][0]+'.jpg'"
                       v-if="!popList[1][5]" />
                  <img class="top1_content_img"
                       :src="popList[1][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[1][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top1_content_img"
                       :src="popList[1][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[1][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top1_content_img"
                       :src="popList[1][5]"
                       v-else />
                  <div class="top1_content_bottom">
                    <div class="top1_content_bottom_0">
                      <img v-if="Number(popList[1][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top1_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[1][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top1_content_bottom_0_price">
                        {{numberWithCommas(popList[1][7])}}
                      </div>
                      <div v-else-if="Number(popList[1][2]) > 0"
                           class="top1_content_bottom_0_price">{{numberWithCommas(popList[1][2])}}</div>
                      <div v-else-if="Number(popList[1][3]) > 0"
                           class="top1_content_bottom_0_price">{{numberWithCommas(popList[1][3])}}</div>
                      <div class="top1_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[1])"
                           v-if="checkBasketIcon(popList[1])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[1])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[1])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[1])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[1])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top1_content_bottom_name"
                         v-if="popList[1][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[1][1] + ' / ' + popList[1][4]}}</div>
                    <div class="top1_content_bottom_name"
                         v-else>{{popList[1][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 2번 -->
              <div class="top2">
                <div class="top2_content">
                  <div class="top2_content_top"
                       v-if="!$empty(popList[2][6].badgeInfo) || (!$empty(popList[2][6].badgeList) && popList[2][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[2][6].badgeInfo) && !$empty(popList[2][6].badgeInfo.imageUrl) && ($empty(popList[2][6].badgeList) || popList[2][6].badgeList.length === 0)"
                         :src="`${popList[2][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[2][6].badgeList) && popList[2][6].badgeList.length > 0"
                         :src="popList[2][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[2][6].badgeList) && popList[2][6].badgeList.length > 1"
                         :src="popList[2][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[2][6].badgeList) && popList[2][6].badgeList.length > 2"
                         :src="popList[2][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top2_content_img"
                       :src="'https://product.sery.co.kr/'+popList[2][0]+'.jpg'"
                       v-if="!popList[2][5]" />
                  <img class="top2_content_img"
                       :src="popList[2][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[2][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top2_content_img"
                       :src="popList[2][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[2][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top2_content_img"
                       :src="popList[2][5]"
                       v-else />
                  <div class="top2_content_bottom">
                    <div class="top2_content_bottom_0">
                      <img v-if="Number(popList[2][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top2_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[2][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top2_content_bottom_0_price">
                        {{numberWithCommas(popList[2][7])}}
                      </div>
                      <div v-else-if="Number(popList[2][2]) > 0"
                           class="top2_content_bottom_0_price">{{numberWithCommas(popList[2][2])}}</div>
                      <div v-else-if="Number(popList[2][3]) > 0"
                           class="top2_content_bottom_0_price">{{numberWithCommas(popList[2][3])}}</div>
                      <div class="top2_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[2])"
                           v-if="checkBasketIcon(popList[2])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[2])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[2])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[2])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[2])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top2_content_bottom_name"
                         v-if="popList[2][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[2][1] + ' / ' + popList[2][4]}}</div>
                    <div class="top2_content_bottom_name"
                         v-else>{{popList[2][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 3번 -->
              <div v-if='popList.length >= 4'
                   class="top3">
                <div class="top3_content">
                  <div class="top3_content_top"
                       v-if="!$empty(popList[3][6].badgeInfo) || (!$empty(popList[3][6].badgeList) && popList[3][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[3][6].badgeInfo) && !$empty(popList[3][6].badgeInfo.imageUrl) && ($empty(popList[3][6].badgeList) || popList[3][6].badgeList.length === 0)"
                         :src="`${popList[3][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[3][6].badgeList) && popList[3][6].badgeList.length > 0"
                         :src="popList[3][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[3][6].badgeList) && popList[3][6].badgeList.length > 1"
                         :src="popList[3][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[3][6].badgeList) && popList[3][6].badgeList.length > 2"
                         :src="popList[3][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top3_content_img"
                       :src="'https://product.sery.co.kr/'+popList[3][0]+'.jpg'"
                       v-if="!popList[3][5]" />
                  <img class="top3_content_img"
                       :src="popList[3][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[3][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top3_content_img"
                       :src="popList[3][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[3][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top3_content_img"
                       :src="popList[3][5]"
                       v-else />
                  <div class="top3_content_bottom">
                    <div class="top3_content_bottom_0">
                      <img v-if="Number(popList[3][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top3_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[3][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top3_content_bottom_0_price">
                        {{numberWithCommas(popList[3][7])}}
                      </div>
                      <div v-else-if="Number(popList[3][2]) > 0"
                           class="top3_content_bottom_0_price">{{numberWithCommas(popList[3][2])}}</div>
                      <div v-else-if="Number(popList[3][3]) > 0"
                           class="top3_content_bottom_0_price">{{numberWithCommas(popList[3][3])}}</div>
                      <div class="top3_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[3])"
                           v-if="checkBasketIcon(popList[3])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[3])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[3])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[3])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[3])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top3_content_bottom_name"
                         v-if="popList[3][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[3][1] + ' / ' + popList[3][4]}}</div>
                    <div class="top3_content_bottom_name"
                         v-else>{{popList[3][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 4번 -->
              <div v-if='popList.length >= 5'
                   class="top4">
                <div class="top4_content">
                  <div class="top4_content_top"
                       v-if="!$empty(popList[4][6].badgeInfo) || (!$empty(popList[4][6].badgeList) && popList[4][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[4][6].badgeInfo) && !$empty(popList[4][6].badgeInfo.imageUrl) && ($empty(popList[4][6].badgeList) || popList[4][6].badgeList.length === 0)"
                         :src="`${popList[4][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[4][6].badgeList) && popList[4][6].badgeList.length > 0"
                         :src="popList[4][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[4][6].badgeList) && popList[4][6].badgeList.length > 1"
                         :src="popList[4][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[4][6].badgeList) && popList[4][6].badgeList.length > 2"
                         :src="popList[4][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top4_content_img"
                       :src="'https://product.sery.co.kr/'+popList[4][0]+'.jpg'"
                       v-if="!popList[4][5]" />
                  <img class="top4_content_img"
                       :src="popList[4][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[4][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top4_content_img"
                       :src="popList[4][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[4][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top4_content_img"
                       :src="popList[4][5]"
                       v-else />
                  <div class="top4_content_bottom">
                    <div class="top4_content_bottom_0">
                      <img v-if="Number(popList[4][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top4_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[4][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top4_content_bottom_0_price">
                        {{numberWithCommas(popList[4][7])}}
                      </div>
                      <div v-else-if="Number(popList[4][2]) > 0"
                           class="top4_content_bottom_0_price">{{numberWithCommas(popList[4][2])}}</div>
                      <div v-else-if="Number(popList[4][3]) > 0"
                           class="top4_content_bottom_0_price">{{numberWithCommas(popList[4][3])}}</div>
                      <div class="top4_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[4])"
                           v-if="checkBasketIcon(popList[4])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[4])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[4])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[4])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[4])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top4_content_bottom_name"
                         v-if="popList[4][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[4][1] + ' / ' + popList[4][4]}}</div>
                    <div class="top4_content_bottom_name"
                         v-else>{{popList[4][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 5번 -->
              <div v-if='popList.length >= 6'
                   class="top5">
                <div class="top5_content">
                  <div class="top5_content_top"
                       v-if="!$empty(popList[5][6].badgeInfo) || (!$empty(popList[5][6].badgeList) && popList[5][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[5][6].badgeInfo) && !$empty(popList[5][6].badgeInfo.imageUrl) && ($empty(popList[5][6].badgeList) || popList[5][6].badgeList.length === 0)"
                         :src="`${popList[5][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[5][6].badgeList) && popList[5][6].badgeList.length > 0"
                         :src="popList[5][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[5][6].badgeList) && popList[5][6].badgeList.length > 1"
                         :src="popList[5][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[5][6].badgeList) && popList[5][6].badgeList.length > 2"
                         :src="popList[5][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top5_content_img"
                       :src="'https://product.sery.co.kr/'+popList[5][0]+'.jpg'"
                       v-if="!popList[5][5]" />
                  <img class="top5_content_img"
                       :src="popList[5][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[5][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top5_content_img"
                       :src="popList[5][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[5][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top5_content_img"
                       :src="popList[5][5]"
                       v-else />
                  <div class="top5_content_bottom">
                    <div class="top5_content_bottom_0">
                      <img v-if="Number(popList[5][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top5_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[5][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top5_content_bottom_0_price">
                        {{numberWithCommas(popList[5][7])}}
                      </div>
                      <div v-else-if="Number(popList[5][2]) > 0"
                           class="top5_content_bottom_0_price">{{numberWithCommas(popList[5][2])}}</div>
                      <div v-else-if="Number(popList[5][3]) > 0"
                           class="top5_content_bottom_0_price">{{numberWithCommas(popList[5][3])}}</div>
                      <div class="top5_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[5])"
                           v-if="checkBasketIcon(popList[5])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[5])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[5])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[5])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[5])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top5_content_bottom_name"
                         v-if="popList[5][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[5][1] + ' / ' + popList[5][4]}}</div>
                    <div class="top5_content_bottom_name"
                         v-else>{{popList[5][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 6번 -->
              <div v-if='popList.length >= 7'
                   class="top6">
                <div class="top6_content">
                  <div class="top6_content_top"
                       v-if="!$empty(popList[6][6].badgeInfo) || (!$empty(popList[6][6].badgeList) && popList[6][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[6][6].badgeInfo) && !$empty(popList[6][6].badgeInfo.imageUrl) && ($empty(popList[6][6].badgeList) || popList[6][6].badgeList.length === 0)"
                         :src="`${popList[6][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[6][6].badgeList) && popList[6][6].badgeList.length > 0"
                         :src="popList[6][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[6][6].badgeList) && popList[6][6].badgeList.length > 1"
                         :src="popList[6][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[6][6].badgeList) && popList[6][6].badgeList.length > 2"
                         :src="popList[6][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top6_content_img"
                       :src="'https://product.sery.co.kr/'+popList[6][0]+'.jpg'"
                       v-if="!popList[6][5]" />
                  <img class="top6_content_img"
                       :src="popList[6][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[6][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top6_content_img"
                       :src="popList[6][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[6][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top6_content_img"
                       :src="popList[6][5]"
                       v-else />
                  <div class="top6_content_bottom">
                    <div class="top6_content_bottom_0">
                      <img v-if="Number(popList[6][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top6_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[6][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top6_content_bottom_0_price">
                        {{numberWithCommas(popList[6][7])}}
                      </div>
                      <div v-else-if="Number(popList[6][2]) > 0"
                           class="top6_content_bottom_0_price">{{numberWithCommas(popList[6][2])}}</div>
                      <div v-else-if="Number(popList[6][3]) > 0"
                           class="top6_content_bottom_0_price">{{numberWithCommas(popList[6][3])}}</div>
                      <div class="top6_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[6])"
                           v-if="checkBasketIcon(popList[6])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[6])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[6])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[6])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[6])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top6_content_bottom_name"
                         v-if="popList[6][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[6][1] + ' / ' + popList[6][4]}}</div>
                    <div class="top6_content_bottom_name"
                         v-else>{{popList[6][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 7번 -->
              <div v-if='popList.length >= 8'
                   class="top7">
                <div class="top7_content">
                  <div class="top7_content_top"
                       v-if="!$empty(popList[7][6].badgeInfo) || (!$empty(popList[7][6].badgeList) && popList[7][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[7][6].badgeInfo) && !$empty(popList[7][6].badgeInfo.imageUrl) && ($empty(popList[7][6].badgeList) || popList[7][6].badgeList.length === 0)"
                         :src="`${popList[7][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[7][6].badgeList) && popList[7][6].badgeList.length > 0"
                         :src="popList[7][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[7][6].badgeList) && popList[7][6].badgeList.length > 1"
                         :src="popList[7][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[7][6].badgeList) && popList[7][6].badgeList.length > 2"
                         :src="popList[7][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top7_content_img"
                       :src="'https://product.sery.co.kr/'+popList[7][0]+'.jpg'"
                       v-if="!popList[7][5]" />
                  <img class="top7_content_img"
                       :src="popList[7][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[7][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top7_content_img"
                       :src="popList[7][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[7][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top7_content_img"
                       :src="popList[7][5]"
                       v-else />
                  <div class="top7_content_bottom">
                    <div class="top7_content_bottom_0">
                      <img v-if="Number(popList[7][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top7_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[7][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top7_content_bottom_0_price">
                        {{numberWithCommas(popList[7][7])}}
                      </div>
                      <div v-else-if="Number(popList[7][2]) > 0"
                           class="top7_content_bottom_0_price">{{numberWithCommas(popList[7][2])}}</div>
                      <div v-else-if="Number(popList[7][3]) > 0"
                           class="top7_content_bottom_0_price">{{numberWithCommas(popList[7][3])}}</div>
                      <div class="top7_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[7])"
                           v-if="checkBasketIcon(popList[7])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[7])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[7])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[7])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[7])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top7_content_bottom_name"
                         v-if="popList[7][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[7][1] + ' / ' + popList[7][4]}}</div>
                    <div class="top7_content_bottom_name"
                         v-else>{{popList[7][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 8번 -->
              <div v-if='popList.length >= 9'
                   class="top8">
                <div class="top8_content">
                  <div class="top8_content_top"
                       v-if="!$empty(popList[8][6].badgeInfo) || (!$empty(popList[8][6].badgeList) && popList[8][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[8][6].badgeInfo) && !$empty(popList[8][6].badgeInfo.imageUrl) && ($empty(popList[8][6].badgeList) || popList[8][6].badgeList.length === 0)"
                         :src="`${popList[8][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[8][6].badgeList) && popList[8][6].badgeList.length > 0"
                         :src="popList[8][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[8][6].badgeList) && popList[8][6].badgeList.length > 1"
                         :src="popList[8][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[8][6].badgeList) && popList[8][6].badgeList.length > 2"
                         :src="popList[8][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top8_content_img"
                       :src="'https://product.sery.co.kr/'+popList[8][0]+'.jpg'"
                       v-if="!popList[8][5]" />
                  <img class="top8_content_img"
                       :src="popList[8][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[8][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top8_content_img"
                       :src="popList[8][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[8][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top8_content_img"
                       :src="popList[8][5]"
                       v-else />
                  <div class="top8_content_bottom">
                    <div class="top8_content_bottom_0">
                      <img v-if="Number(popList[8][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top8_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[8][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top8_content_bottom_0_price">
                        {{numberWithCommas(popList[8][7])}}
                      </div>
                      <div v-else-if="Number(popList[8][2]) > 0"
                           class="top8_content_bottom_0_price">{{numberWithCommas(popList[8][2])}}</div>
                      <div v-else-if="Number(popList[8][3]) > 0"
                           class="top8_content_bottom_0_price">{{numberWithCommas(popList[8][3])}}</div>
                      <div class="top8_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[8])"
                           v-if="checkBasketIcon(popList[8])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[8])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[8])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[8])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[8])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top8_content_bottom_name"
                         v-if="popList[8][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[8][1] + ' / ' + popList[8][4]}}</div>
                    <div class="top8_content_bottom_name"
                         v-else>{{popList[8][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 9번 -->
              <div v-if='popList.length >= 10'
                   class="top9">
                <div class="top9_content">
                  <div class="top9_content_top"
                       v-if="!$empty(popList[9][6].badgeInfo) || (!$empty(popList[9][6].badgeList) && popList[9][6].badgeList.length > 0)">
                    <img v-if="!$empty(popList[9][6].badgeInfo) && !$empty(popList[9][6].badgeInfo.imageUrl) && ($empty(popList[9][6].badgeList) || popList[9][6].badgeList.length === 0)"
                         :src="`${popList[9][6].badgeInfo.imageUrl}`"
                         style="width: 100%"
                         alt="">
                    <img v-if="!$empty(popList[9][6].badgeList) && popList[9][6].badgeList.length > 0"
                         :src="popList[9][6].badgeList[0].imageUrl"
                         class="badge-image"
                         alt="" />
                    <img v-if="!$empty(popList[9][6].badgeList) && popList[9][6].badgeList.length > 1"
                         :src="popList[9][6].badgeList[1].imageUrl"
                         class="badge-image badge-image--1"
                         alt="" />
                    <img v-if="!$empty(popList[9][6].badgeList) && popList[9][6].badgeList.length > 2"
                         :src="popList[9][6].badgeList[2].imageUrl"
                         class="badge-image badge-image--2"
                         alt="" />
                  </div>
                  <img class="top9_content_img"
                       :src="'https://product.sery.co.kr/'+popList[9][0]+'.jpg'"
                       v-if="!popList[9][5]" />
                  <img class="top9_content_img"
                       :src="popList[9][5] + '?w=400&f=webp&q=70'"
                       v-else-if='popList[9][5].indexOf("cloudfront.net") > -1 && deviceOs !== "iPhone" && !isLowFirefoxVersion' />
                  <img class="top9_content_img"
                       :src="popList[9][5] + '?w=400&f=png&q=70'"
                       v-else-if='popList[9][5].indexOf("cloudfront.net") > -1 && deviceOs === "iPhone"' />
                  <img class="top9_content_img"
                       :src="popList[9][5]"
                       v-else />
                  <div class="top9_content_bottom">
                    <div class="top9_content_bottom_0">
                      <img v-if="Number(popList[9][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top9_content_bottom_0_img"
                           src="@/assets/icon/app_price.svg" />
                      <div v-if="Number(popList[9][7]) > 0 && $store.state.storeSeq !== '051_00000501'"
                           class="top9_content_bottom_0_price">
                        {{numberWithCommas(popList[9][7])}}
                      </div>
                      <div v-else-if="Number(popList[9][2]) > 0"
                           class="top9_content_bottom_0_price">{{numberWithCommas(popList[9][2])}}</div>
                      <div v-else-if="Number(popList[9][3]) > 0"
                           class="top9_content_bottom_0_price">{{numberWithCommas(popList[9][3])}}</div>
                      <div class="top9_content_bottom_0_icon"
                           @click.stop="handleAddCart2(popList[9])"
                           v-if="checkBasketIcon(popList[9])">
                        <template v-if="!checkPacking()">
                          <img class="basket-icon"
                               src="@/assets/icon/icon_cart_outline.svg"
                               v-if="checkBasketIn(popList[9])" />
                          <img src="@/assets/btn_cart_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img class="basket-icon"
                               src="@/assets/icon/btn_packing_outline.svg"
                               v-if="checkBasketIn(popList[9])" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               class="basket-icon"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div @click.stop="handleAddCart2(popList[9])"
                           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img class="basket-icon"
                             src="@/assets/icon/btn_wish_outline.svg"
                             v-if="checkBasketIn(popList[9])" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             class="basket-icon"
                             v-else
                             alt="">
                      </div>
                    </div>
                    <div class="top9_content_bottom_name"
                         v-if="popList[9][4] !== '' && productStandardStatus !== '' && productStandardStatus !== null">
                      {{popList[9][1] + ' / ' + popList[9][4]}}</div>
                    <div class="top9_content_bottom_name"
                         v-else>{{popList[9][1]}}</div>
                  </div>
                </div>
              </div>
              <!-- 행사날짜 -->
              <div style="position: absolute; bottom: 0%; right: 2%; font-size: 17px; font-weight: bold; z-index: 40;">
                <div style="text-align: right; background-color: rgba(255, 255, 255, 0.3); padding: 0 15px 0 15px;">
                  {{eventDate}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 대표이미지 있음 end -->
        <div class="image-middle__container">
          <div class="image-middle__contents"
               v-for="(image, index) in images.middle"
               :key="index">
            <img :src="image"
                 class="image"
                 alt="">
          </div>
        </div>
        <div class="event__contents"
             v-if="!$empty(guide)"
             v-html="guide"></div>
        <div class="image-bottom__container">
          <div class="image-bottom__contents"
               v-for="(image, index) in images.bottom"
               :key="index">
            <img :src="image"
                 class="image"
                 alt="">
          </div>
        </div>
        <img src=""
             alt="">
      </div>
      <div v-if="popTopList.length > 0"
           style="background: white;">
        <div v-for="(item, index) in popTopList"
             :key="index"
             :id="`popBox_${index}`"
             :class="[Number(item.popTop.type) === 0 ? 'pop-top-box-0' : 'pop-top-box']">
          <img v-if="!$empty(item.popTop) && !$empty(item.popTop.imageUrl)"
               :src="item.popTop.imageUrl"
               class="box__background" />
          <div class="box__container">
            <div class="box__top">
              <div class="productBadgeDiv"
                   v-if="print && (!$empty(item.badgeInfo) || (!$empty(item.badgeList) && item.badgeList.length > 0))">
                <img :src="`${item.badgeInfo.imageUrl}?w=50&f=png`"
                     v-if="!$empty(item.badgeInfo.imageUrl) && ($empty(item.badgeList) || item.badgeList.length === 0)"
                     class="badge-image"
                     alt="">
                <img v-if="!$empty(item.badgeList) && item.badgeList.length > 0"
                     :src="`${item.badgeList[0].imageUrl}?w=50&f=png`"
                     class="badge-image"
                     alt="" />
                <img v-if="!$empty(item.badgeList) && item.badgeList.length > 1"
                     :src="`${item.badgeList[1].imageUrl}?w=50&f=png`"
                     class="badge-image badge-image--1"
                     alt="" />
                <img v-if="!$empty(item.badgeList) && item.badgeList.length > 2"
                     :src="`${item.badgeList[2].imageUrl}?w=50&f=png`"
                     class="badge-image badge-image--2"
                     alt="" />
              </div>
              <div class="productBadgeDiv"
                   v-else-if="!$empty(item.badgeInfo) || (!$empty(item.badgeList) && item.badgeList.length > 0)">
                <img :src="`${item.badgeInfo.imageUrl}`"
                     v-if="!$empty(item.badgeInfo.imageUrl) && ($empty(item.badgeList) || item.badgeList.length === 0)"
                     class="badge-image"
                     alt="">
                <img v-if="!$empty(item.badgeList) && item.badgeList.length > 0"
                     :src="item.badgeList[0].imageUrl"
                     class="badge-image"
                     alt="" />
                <img v-if="!$empty(item.badgeList) && item.badgeList.length > 1"
                     :src="item.badgeList[1].imageUrl"
                     class="badge-image badge-image--1"
                     alt="" />
                <img v-if="!$empty(item.badgeList) && item.badgeList.length > 2"
                     :src="item.badgeList[2].imageUrl"
                     class="badge-image badge-image--2"
                     alt="" />
              </div>
              <div class="imageDivInner">
                <img :src="`${item.imageUrl}${$store.state.storeSeq !== '051_00000868' ? '?w=400&f=webp&q=70' : ''}`"
                     :class="{'productImage': $empty(item.popTop) || $empty(item.popTop.imageUrl)}"
                     v-if="!$empty(item.imageUrl)"
                     @error="errorImage">
                <img src="@/assets/no_item_image.png"
                     :class="{'productImage': $empty(item.popTop) || $empty(item.popTop.imageUrl)}"
                     v-else>
              </div>
            </div>
            <div class="box__bottom">
              <div class="top1"
                   :style="{bottom: appFlag === '1' && $store.state.storeSeq !== '051_00000501' ? topPosition - 5 + '%' : topPosition + '%'}">
                <div class="name">
                  {{ item.name }}
                </div>
                <div v-if="!$empty(item.standard)"
                     class="standard">
                  {{ item.standard }}
                </div>
              </div>
              <div v-if="appFlag === '1' && $store.state.storeSeq !== '051_00000501'"
                   class="bottom">
                <div v-if="!$empty(item.costPrice) && Number(item.costPrice) > 0"
                     class="price flex align-center justify-center cost_price">
                  {{ numberWithCommas(item.costPrice) }}
                </div>
                <div v-else
                     class="price flex align-center justify-center cost_price">
                </div>
                <div
                     v-if="!$empty(item.sellPrice) && Number(item.sellPrice) > 0 && !$empty(item.appPrice) && Number(item.appPrice) > 0">
                  <div class="sell_price">
                    <div>정상가</div>
                    <div class="price flex align-center justify-center">
                      {{ numberWithCommas(item.sellPrice) }}
                    </div>
                  </div>
                  <div class="app_price">
                    <div>앱행사</div>
                    <div class="price flex align-center justify-center">
                      {{ numberWithCommas(item.appPrice) }}
                    </div>
                  </div>
                </div>
                <div v-else-if="!$empty(item.sellPrice) && Number(item.sellPrice) > 0">
                  <div class="sell_price">
                    <div>행사가</div>
                    <div v-if="!item.currencyUnitType || item.currencyUnitType === 0"
                         class="price flex align-center justify-center">
                      {{ numberWithCommas(item.sellPrice) }}
                    </div>
                    <div v-if="item.currencyUnitType && item.currencyUnitType === 1"
                         class="price flex align-center justify-center">
                      {{ numberWithCommas2(item.sellPrice) }}<span>원 ~</span>
                    </div>
                    <div v-if="item.currencyUnitType && item.currencyUnitType === 2"
                         class="price flex align-center justify-center">
                      {{ numberWithCommas2(item.sellPrice) }}<span>원 부터</span>
                    </div>
                  </div>
                </div>
                <div v-else-if="!$empty(item.appPrice) && Number(item.appPrice) > 0">
                  <div class="app_price">
                    <div>앱행사</div>
                    <div class="price flex align-center justify-center">
                      {{ numberWithCommas(item.appPrice) }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else
                   class="bottom2">
                <div v-if="!$empty(item.costPrice) && Number(item.costPrice) > 0"
                     class="price flex align-center justify-center cost_price">
                  {{ numberWithCommas(item.costPrice) }}
                </div>
                <div v-else
                     class="price flex align-center justify-center cost_price">
                </div>
                <div v-if="!$empty(item.sellPrice) && Number(item.sellPrice) > 0">
                  <div v-if="!item.currencyUnitType || item.currencyUnitType === 0"
                       class="price flex align-center justify-center sell_price">
                    {{ numberWithCommas(item.sellPrice) }}
                  </div>
                  <div v-if="item.currencyUnitType && item.currencyUnitType === 1"
                       class="price flex align-center justify-center sell_price">
                    {{ numberWithCommas2(item.sellPrice) }}<span>원 ~</span>
                  </div>
                  <div v-if="item.currencyUnitType && item.currencyUnitType === 2"
                       class="price flex align-center justify-center sell_price">
                    {{ numberWithCommas2(item.sellPrice) }}<span>원 부터</span>
                  </div>
                </div>
              </div>
              <div class="pop-top-box--cart1"
                   @click.stop="handleAddCart(item)"
                   v-if="!print && item.sell_price > 0 && $store.state.storeInfo.APP_FLAG === '1' && $store.state.storeSeq !== '051_00000501' &&
                    Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(item.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                <template v-if="!checkPacking()">
                  <img src="@/assets/btn_cart2.svg"
                       v-if="!item.isAddCart" />
                  <img src="@/assets/btn_cart_on.svg"
                       v-else
                       alt="">
                </template>
                <template v-else>
                  <img src="@/assets/icon/btn_packing.svg"
                       v-if="!item.isAddCart" />
                  <img src="@/assets/icon/btn_packing_on.svg"
                       v-else
                       alt="">
                </template>
              </div>
              <div class='pop-top-box--cart'
                   v-else-if="!print && item.sell_price > 0 &&
                    Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(item.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                <img src="@/assets/icon/cart_minus.svg"
                     @click.stop="[item.order_qty > 0 ? item.order_qty-- : 0, inBasket(item, false)]" />
                <span>{{  item.order_qty }}</span>
                <img src="@/assets/icon/cart_plus.svg"
                     @click.stop="[item.order_qty++, inBasket(item, false)]" />
              </div>
              <div class="pop-top-box--cart1"
                   @click.stop="handleAddCart(item)"
                   v-else-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                      $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                      $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                      $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                      $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                      $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                      $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                <img src="@/assets/icon/btn_wish.svg"
                     v-if="!item.isAddCart" />
                <img src="@/assets/icon/btn_wish_on.svg"
                     v-else
                     alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="body"
           class="body">
        <div class="content"
             v-if="$store.state.eventSeq !== '' && (selectCategory === 0 || selectCategory === 1)">
          <!-- 전단행사 -->
          <div class="itemList"
               v-if="eventProductInfo.length > 0">
            <div v-for="(category, $index) in eventProductInfo"
                 :key="$index"
                 :id="`category_${category.CATEGORY_SEQ}`"
                 class="productItem-div event">
              <div class="banner-image__contents"
                   v-if="(!$empty(category.eachList) && category.eachList.length > 0) || !$empty(category.MEMO) || (!$empty(category.subCategory) && category.subCategory.length > 0)">
                <img class="banner-image"
                     src="@/assets/banner/coner2.png"
                     alt=""
                     v-if="category.CATEGORY_NAME === '야채코너' && $empty(category.IMAGE_URL)">
                <div class="banner-image coner-contents background-image"
                     :style="{'background-image': `url(${category.IMAGE_URL})`, 'font-size': '50px'}"
                     v-else-if="category.CATEGORY_NAME === '야채코너' && !$empty(category.IMAGE_URL)">
                  {{category.CATEGORY_NAME}}
                </div>
                <img class="banner-image"
                     src="@/assets/banner/coner3.png"
                     alt=""
                     v-else-if="category.CATEGORY_NAME === '과일코너' && $empty(category.IMAGE_URL)">
                <div class="banner-image coner-contents background-image"
                     :style="{'background-image': `url(${category.IMAGE_URL})`, 'font-size': '50px'}"
                     v-else-if="category.CATEGORY_NAME === '과일코너' && !$empty(category.IMAGE_URL)">
                  {{category.CATEGORY_NAME}}
                </div>
                <img class="banner-image"
                     src="@/assets/banner/coner1.png"
                     alt=""
                     v-else-if="category.CATEGORY_NAME === '정육코너' && $empty(category.IMAGE_URL)">
                <div class="banner-image coner-contents background-image"
                     :style="{'background-image': `url(${category.IMAGE_URL})`, 'font-size': '50px'}"
                     v-else-if="category.CATEGORY_NAME === '정육코너' && !$empty(category.IMAGE_URL)">
                  {{category.CATEGORY_NAME}}
                </div>
                <img class="banner-image"
                     src="@/assets/banner/coner4.png"
                     alt=""
                     v-else-if="category.CATEGORY_NAME === '수산코너' && $empty(category.IMAGE_URL)">
                <div class="banner-image coner-contents background-image"
                     :style="{'background-image': `url(${category.IMAGE_URL})`, 'font-size': '50px'}"
                     v-else-if="category.CATEGORY_NAME === '수산코너' && !$empty(category.IMAGE_URL)">
                  {{category.CATEGORY_NAME}}
                </div>
                <img class="banner-image"
                     src="@/assets/banner/coner5.png"
                     alt=""
                     v-else-if="category.CATEGORY_NAME === '공산코너' && $empty(category.IMAGE_URL)">
                <div class="banner-image coner-contents background-image"
                     :style="{'background-image': `url(${category.IMAGE_URL})`, 'font-size': '50px'}"
                     v-else-if="category.CATEGORY_NAME === '공산코너' && !$empty(category.IMAGE_URL)">
                  {{category.CATEGORY_NAME}}
                </div>
                <div class="banner-image coner-contents background-image"
                     :style="{'background-image': `url(${category.IMAGE_URL})`, 'font-size': '50px'}"
                     v-else>
                  {{category.CATEGORY_NAME}}
                </div>
              </div>
              <div class='product-item__wrap'
                   :class="[
                {'product-item__wrap_1': !$empty(item.popTop) && !$empty(item.popTop.imageUrl)},
                {'product-item__wrap_3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                {'product-item__wrap_4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                {'product-item__wrap_0' : $store.state.storeInfo.VIEW_TYPE === '1'}]"
                   v-for="(item, index) in category.eachList"
                   :key="index">
                <div v-if="!$empty(item.popTop) && !$empty(item.popTop.imageUrl)"
                     :class="[Number(item.popTop.type) === 0 ? 'pop-top-box-0' : 'pop-top-box']">
                  <img v-if="!$empty(item.popTop) && !$empty(item.popTop.imageUrl)"
                       :src="item.popTop.imageUrl"
                       class="box__background" />
                  <div class="box__container">
                    <div class="box__top">
                      <div class="productBadgeDiv"
                           v-if="print && (!$empty(item.badgeInfo) || (!$empty(item.badgeList) && item.badgeList.length > 0))">
                        <img :src="`${item.badgeInfo.imageUrl}?w=50&f=png`"
                             v-if="!$empty(item.badgeInfo.imageUrl) && ($empty(item.badgeList) || item.badgeList.length === 0)"
                             class="badge-image"
                             alt="">
                        <img v-if="!$empty(item.badgeList) && item.badgeList.length > 0"
                             :src="`${item.badgeList[0].imageUrl}?w=50&f=png`"
                             class="badge-image"
                             alt="" />
                        <img v-if="!$empty(item.badgeList) && item.badgeList.length > 1"
                             :src="`${item.badgeList[1].imageUrl}?w=50&f=png`"
                             class="badge-image badge-image--1"
                             alt="" />
                        <img v-if="!$empty(item.badgeList) && item.badgeList.length > 2"
                             :src="`${item.badgeList[2].imageUrl}?w=50&f=png`"
                             class="badge-image badge-image--2"
                             alt="" />
                      </div>
                      <div class="productBadgeDiv"
                           v-else-if="!$empty(item.badgeInfo) || (!$empty(item.badgeList) && item.badgeList.length > 0)">
                        <img :src="`${item.badgeInfo.imageUrl}`"
                             v-if="!$empty(item.badgeInfo.imageUrl) && ($empty(item.badgeList) || item.badgeList.length === 0)"
                             class="badge-image"
                             alt="">
                        <img v-if="!$empty(item.badgeList) && item.badgeList.length > 0"
                             :src="item.badgeList[0].imageUrl"
                             class="badge-image"
                             alt="" />
                        <img v-if="!$empty(item.badgeList) && item.badgeList.length > 1"
                             :src="item.badgeList[1].imageUrl"
                             class="badge-image badge-image--1"
                             alt="" />
                        <img v-if="!$empty(item.badgeList) && item.badgeList.length > 2"
                             :src="item.badgeList[2].imageUrl"
                             class="badge-image badge-image--2"
                             alt="" />
                      </div>
                      <div class="imageDivInner"
                           :style="[$store.state.storeInfo.VIEW_TYPE === '1' && Number(item.popTop.type) === 0 ? {'margin-top': '20%'} : {} ]">
                        <img :src="`${item.imageUrl}${$store.state.storeSeq !== '051_00000868' ? '?w=400&f=webp&q=70' : ''}`"
                             :class="{'productImage': $empty(item.popTop) || $empty(item.popTop.imageUrl)}"
                             :style="[$store.state.storeInfo.VIEW_TYPE === '1' && Number(item.popTop.type) === 0 ? {'width': '68%'} : {},
                              $store.state.storeInfo.VIEW_TYPE === '1' && Number(item.popTop.type) !== 0 ? {'height': '60%'} : {}]"
                             v-if="!$empty(item.imageUrl)"
                             @error="errorImage">
                        <img src="@/assets/no_item_image.png"
                             :class="{'productImage': $empty(item.popTop) || $empty(item.popTop.imageUrl)}"
                             v-else>
                      </div>
                    </div>
                    <div class="box__bottom"
                         :style="[$store.state.storeInfo.VIEW_TYPE === '1' && Number(item.popTop.type) !== 0 ? {'width': '50%', 'margin-left': '2vw'} : {} ]">
                      <div v-if="$store.state.storeInfo.VIEW_TYPE === '1'"
                           class="top2">
                        <div class="name"
                             :style="{color: $store.state.storeInfo.VIEW_TYPE === '1' ? '#F00' : '#000'}">
                          {{ item.name }}
                        </div>
                        <div class="standard">
                          <template v-for='(c, index) in lineBreak(item.standard)'>
                            {{ c }} <br :key='index'>
                          </template>
                        </div>
                      </div>
                      <div v-else
                           class="top1"
                           :style="{bottom: appFlag === '1' && $store.state.storeSeq !== '051_00000501' ? topPosition - 5 + '%' : topPosition + '%'}">
                        <div class="name"
                             :style="{color: $store.state.storeInfo.VIEW_TYPE === '1' ? '#F00' : '#000'}">
                          {{ item.name }}
                        </div>
                        <div v-if="!$empty(item.standard)"
                             class="standard">
                          {{ item.standard }}
                        </div>
                      </div>
                      <div v-if="appFlag === '1' && $store.state.storeSeq !== '051_00000501'"
                           class="bottom">
                        <div v-if="!$empty(item.costPrice) && Number(item.costPrice) > 0"
                             class="price flex align-center justify-center cost_price">
                          {{ numberWithCommas(item.costPrice) }}
                        </div>
                        <div v-else
                             class="price flex align-center justify-center cost_price">
                        </div>
                        <div
                             v-if="!$empty(item.sellPrice) && Number(item.sellPrice) > 0 && !$empty(item.appPrice) && Number(item.appPrice) > 0">
                          <div class="sell_price">
                            <div>행사가</div>
                            <div v-if="!item.currencyUnitType || item.currencyUnitType === 0"
                                 class="price flex align-center justify-center">
                              {{ numberWithCommas(item.sellPrice) }}
                            </div>
                            <div v-if="item.currencyUnitType && item.currencyUnitType === 1"
                                 class="price flex align-center justify-center">
                              {{ numberWithCommas2(item.sellPrice) }}<span>원 ~</span>
                            </div>
                            <div v-if="item.currencyUnitType && item.currencyUnitType === 2"
                                 class="price flex align-center justify-center">
                              {{ numberWithCommas2(item.sellPrice) }}<span>원 부터</span>
                            </div>
                          </div>
                          <div class="app_price">
                            <div>앱행사</div>
                            <div class="price flex align-center justify-center">
                              {{ numberWithCommas(item.appPrice) }}
                            </div>
                          </div>
                        </div>
                        <div v-else-if="!$empty(item.sellPrice) && Number(item.sellPrice) > 0">
                          <div class="sell_price">
                            <div>행사가</div>
                            <div v-if="!item.currencyUnitType || item.currencyUnitType === 0"
                                 class="price flex align-center justify-center">
                              {{ numberWithCommas(item.sellPrice) }}
                            </div>
                            <div v-if="item.currencyUnitType && item.currencyUnitType === 1"
                                 class="price flex align-center justify-center">
                              {{ numberWithCommas2(item.sellPrice) }}<span>원 ~</span>
                            </div>
                            <div v-if="item.currencyUnitType && item.currencyUnitType === 2"
                                 class="price flex align-center justify-center">
                              {{ numberWithCommas2(item.sellPrice) }}<span>원 부터</span>
                            </div>
                          </div>
                        </div>
                        <div v-else-if="!$empty(item.appPrice) && Number(item.appPrice) > 0">
                          <div class="app_price">
                            <div>앱행사</div>
                            <div class="price flex align-center justify-center">
                              {{ numberWithCommas(item.appPrice) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else
                           class="bottom2">
                        <div v-if="!$empty(item.costPrice) && Number(item.costPrice) > 0"
                             class="price flex align-center justify-center cost_price">
                          {{ numberWithCommas(item.costPrice) }}
                        </div>
                        <div v-else
                             class="price flex align-center justify-center cost_price">
                        </div>
                        <div v-if="!$empty(item.sellPrice) && Number(item.sellPrice) > 0">
                          <div v-if="!item.currencyUnitType || item.currencyUnitType === 0"
                               class="price flex align-center justify-center sell_price">
                            {{ numberWithCommas(item.sellPrice) }}
                          </div>
                          <div v-if="item.currencyUnitType && item.currencyUnitType === 1"
                               class="price flex align-center justify-center sell_price">
                            {{ numberWithCommas2(item.sellPrice) }}<span>원 ~</span>
                          </div>
                          <div v-if="item.currencyUnitType && item.currencyUnitType === 2"
                               class="price flex align-center justify-center sell_price">
                            {{ numberWithCommas2(item.sellPrice) }}<span>원 부터</span>
                          </div>
                        </div>
                      </div>
                      <div class="pop-top-box--cart1"
                           @click.stop="handleAddCart(item)"
                           v-if="!print && item.sell_price > 0 && $store.state.storeInfo.APP_FLAG === '1' && $store.state.storeSeq !== '051_00000501' &&
                          Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(item.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                        <template v-if="!checkPacking()">
                          <img src="@/assets/btn_cart2.svg"
                               v-if="!item.isAddCart" />
                          <img src="@/assets/btn_cart_on.svg"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img src="@/assets/icon/btn_packing.svg"
                               v-if="!item.isAddCart" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div class='pop-top-box--cart'
                           v-else-if="!print && item.sell_price > 0 &&
                          Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(item.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                        <img src="@/assets/icon/cart_minus.svg"
                             @click.stop="[item.order_qty > 0 ? item.order_qty-- : 0, inBasket(item, false)]" />
                        <span>{{  item.order_qty }}</span>
                        <img src="@/assets/icon/cart_plus.svg"
                             @click.stop="[item.order_qty++, inBasket(item, false)]" />
                      </div>
                      <div class="pop-top-box--cart1"
                           @click.stop="handleAddCart(item)"
                           v-else-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img src="@/assets/icon/btn_wish.svg"
                             v-if="!item.isAddCart" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             v-else
                             alt="">
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else
                     class="productItem"
                     @click.stop="selectProduct(item)">
                  <div class='productImageDiv'
                       :class="[{'productImageDiv_3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                    {'productImageDiv_4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                    {'productImageDiv_0' : $store.state.storeInfo.VIEW_TYPE === '1'}]">
                    <div class="productBadgeDiv"
                         v-if="print && (!$empty(item.badgeInfo) || (!$empty(item.badgeList) && item.badgeList.length > 0))">
                      <img :src="`${item.badgeInfo.imageUrl}?w=50&f=png`"
                           v-if="!$empty(item.badgeInfo.imageUrl) && ($empty(item.badgeList) || item.badgeList.length === 0)"
                           class="badge-image"
                           alt="">
                      <img v-if="!$empty(item.badgeList) && item.badgeList.length > 0"
                           :src="`${item.badgeList[0].imageUrl}?w=50&f=png`"
                           class="badge-image"
                           alt="" />
                      <img v-if="!$empty(item.badgeList) && item.badgeList.length > 1"
                           :src="`${item.badgeList[1].imageUrl}?w=50&f=png`"
                           class="badge-image badge-image--1"
                           alt="" />
                      <img v-if="!$empty(item.badgeList) && item.badgeList.length > 2"
                           :src="`${item.badgeList[2].imageUrl}?w=50&f=png`"
                           class="badge-image badge-image--2"
                           alt="" />
                    </div>
                    <div class="productBadgeDiv"
                         v-else-if="!$empty(item.badgeInfo) || (!$empty(item.badgeList) && item.badgeList.length > 0)">
                      <img :src="`${item.badgeInfo.imageUrl}`"
                           v-if="!$empty(item.badgeInfo.imageUrl) && ($empty(item.badgeList) || item.badgeList.length === 0)"
                           class="badge-image"
                           alt="">
                      <img v-if="!$empty(item.badgeList) && item.badgeList.length > 0"
                           :src="item.badgeList[0].imageUrl"
                           class="badge-image"
                           alt="" />
                      <img v-if="!$empty(item.badgeList) && item.badgeList.length > 1"
                           :src="item.badgeList[1].imageUrl"
                           class="badge-image badge-image--1"
                           alt="" />
                      <img v-if="!$empty(item.badgeList) && item.badgeList.length > 2"
                           :src="item.badgeList[2].imageUrl"
                           class="badge-image badge-image--2"
                           alt="" />
                    </div>
                    <div class="imageDivInner">
                      <img :src="`${item.imageUrl}${$store.state.storeSeq !== '051_00000868' ? '?w=400&f=webp&q=70' : ''}`"
                           class="productImage"
                           v-if="!$empty(item.imageUrl)"
                           @error="errorImage">
                      <img src="@/assets/no_item_image.png"
                           class="productImage"
                           v-else>
                    </div>
                    <div class="product-button-share__contents"
                         @click.stop="handleAddCart(item)"
                         v-if="!print && item.sell_price > 0 && $store.state.storeInfo.APP_FLAG === '1' && $store.state.storeSeq !== '051_00000501' &&
                        Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(item.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                      <template v-if="!checkPacking()">
                        <img src="@/assets/btn_cart2.svg"
                             style="width: 48px;"
                             v-if="!item.isAddCart" />
                        <img src="@/assets/btn_cart_on.svg"
                             v-else
                             alt="">
                      </template>
                      <template v-else>
                        <img src="@/assets/icon/btn_packing.svg"
                             v-if="!item.isAddCart" />
                        <img src="@/assets/icon/btn_packing_on.svg"
                             v-else
                             alt="">
                      </template>
                    </div>
                    <div class="product-button-share__contents"
                         @click.stop="handleAddCart(item)"
                         v-else-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 && $store.state.storeInfo.APP_FLAG === '1' &&
                          $store.state.storeSeq !== '051_00000501' &&
                          $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                          $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                          $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                      <img src="@/assets/icon/btn_wish.svg"
                           v-if="!item.isAddCart" />
                      <img src="@/assets/icon/btn_wish_on.svg"
                           v-else
                           alt="">
                    </div>
                    <div class="product-button-share__contents"
                         v-else-if="!print && item.sell_price > 0 && ($empty(item.app_price) || item.app_price === '' || item.app_price === '0') && $store.state.storeInfo.VIEW_TYPE === '2'">
                      <img src="@/assets/icon/icon_share.png"
                           class="product-button-share__icon"
                           alt=""
                           @click.stop="productShare($event, item, index)">
                    </div>
                  </div>
                  <div v-if="($store.state.storeInfo.APP_FLAG !== '1' || $store.state.storeSeq === '051_00000501') && $store.state.storeInfo.VIEW_TYPE !== '1'"
                       class='product-bottom'
                       :class="[{'product-bottom_3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                      {'product-bottom_4' : $store.state.storeInfo.VIEW_TYPE === '4'}]">
                    <div class="productNameDiv">
                      {{item.name}}
                    </div>
                    <div class="product-bottom--price"
                         v-if="item.sell_price > 0">
                      <span class="cost-price price__contents"
                            v-if="item.cost_price > 0">{{numberWithCommas(item.cost_price)}}</span>
                      <span class="standard price__contents">
                        {{`${!$empty(item.standard) && item.standard !== 'null' ? item.standard : ''}`}}</span>
                      <div v-if="!item.currencyUnitType || item.currencyUnitType === 0"
                           class="sell-price price__contents">{{numberWithCommas(item.sell_price)}}</div>
                      <div v-if="item.currencyUnitType && item.currencyUnitType === 1"
                           class="sell-price price__contents">{{ numberWithCommas2(item.sell_price) }}<span>원 ~</span>
                      </div>
                      <div v-if="item.currencyUnitType && item.currencyUnitType === 2"
                           class="sell-price price__contents">{{ numberWithCommas2(item.sell_price) }}<span>원 부터</span>
                      </div>
                    </div>
                    <div class='product-bottom--cart'
                         :class="[{'product-bottom--cart3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                      {'product-bottom--cart4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                      {'product-bottom--cart1' : $store.state.storeInfo.VIEW_TYPE === '1'}]"
                         v-if="!print && item.sell_price > 0 &&
                        Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(item.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                      <img src="@/assets/icon/cart_minus.svg"
                           @click.stop="[item.order_qty > 0 ? item.order_qty-- : 0, inBasket(item, false)]" />
                      <span>{{  item.order_qty }}</span>
                      <img src="@/assets/icon/cart_plus.svg"
                           @click.stop="[item.order_qty++, inBasket(item, false)]" />
                    </div>
                    <div class="product-bottom--cart"
                         @click.stop="handleAddCart(item)"
                         v-else-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                          $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                          $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                          $store.state.storeSeq !== '051_00000218' &&
                          $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                      <img src="@/assets/icon/btn_wish.svg"
                           v-if="!item.isAddCart" />
                      <img src="@/assets/icon/btn_wish_on.svg"
                           v-else
                           alt="">
                    </div>
                    <div v-else
                         class='product-bottom--cart'
                         :class="[{'product-bottom--cart3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                      {'product-bottom--cart4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                      {'product-bottom--cart0' : $store.state.storeInfo.VIEW_TYPE === '1'}]"></div>
                  </div>
                  <div v-else-if="$store.state.storeInfo.VIEW_TYPE !== '1'"
                       class="product-bottom2"
                       :class="[{'product-bottom3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                      {'product-bottom4' : $store.state.storeInfo.VIEW_TYPE === '4'}]">
                    <div class="productNameDiv2">
                      {{item.name}}
                    </div>
                    <div
                         :class="{'productNameDiv2': $store.state.storeSeq === '010_12345857', 'product-standard__contents': $store.state.storeSeq !== '010_12345857'}">
                      {{`${!$empty(item.standard) && item.standard !== 'null' ? item.standard : ''}`}}</div>
                    <div v-if="!$empty(item.sell_price) && Number(item.sell_price) > 0"
                         class="product-bottom2"
                         :class="[{'product-bottom3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                        {'product-bottom4' : $store.state.storeInfo.VIEW_TYPE === '4'}]">
                      <div class="product-bottom--cost-price">
                        <!-- 정상가 -->
                        <span class="cost-price price__contents"
                              v-if="item.cost_price > 0">{{numberWithCommas2(item.cost_price)}}</span>
                        <span v-else
                              class="cost-price price__contents"
                              style="text-decoration: none;">&nbsp;</span>
                      </div>
                      <div v-if="!$empty(item.sell_price) && item.sell_price !== '' && item.sell_price !== '0'"
                           class="product-bottom--sell-price">
                        <!-- 행사가 -->
                        <div>전단할인가</div>
                        <div>{{numberWithCommas2(item.sell_price)}}</div>
                      </div>
                    </div>
                    <div v-if="!$empty(item.app_price) && item.app_price !== '' && item.app_price !== '0'"
                         class="product-bottom--app-price">
                      <!-- 앱특별가 -->
                      <div>앱 할인가</div>
                      <div>{{numberWithCommas2(item.app_price)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="textarea"
                   v-if="!$empty(category.MEMO)">{{category.MEMO}}</div>
              <div v-for="(subCategory, subIndex) in category.subCategory"
                   :key="`${subCategory.name}_${subIndex}`"
                   class="productItem-div event">
                <div class="banner-image__contents sub-corner"
                     v-if="!$empty(subCategory.eachList) && subCategory.eachList.length > 0">
                  <div class="banner-image coner-contents">
                    {{subCategory.name}}
                  </div>
                </div>
                <div class="product-item__wrap"
                     :class="[{'product-item__wrap_3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                  {'product-item__wrap_4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                  {'product-item__wrap_0' : $store.state.storeInfo.VIEW_TYPE === '1'}]"
                     v-for="(subItem, subItemIndex) in subCategory.eachList"
                     :key="`${subIndex}_${subItemIndex}`">
                  <div class="productItem"
                       @click.stop="selectProduct(subItem)">
                    <div class="productImageDiv"
                         :class="[{'productImageDiv_3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                      {'productImageDiv_4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                      {'productImageDiv_0' : $store.state.storeInfo.VIEW_TYPE === '1'}]">
                      <div class="productBadgeDiv"
                           v-if="print && (!$empty(subItem.badgeInfo) || (!$empty(subItem.badgeList) && subItem.badgeList.length > 0))">
                        <img :src="`${subItem.badgeInfo.imageUrl}?w=50&f=png`"
                             v-if="!$empty(subItem.badgeInfo.imageUrl) && ($empty(subItem.badgeList) || subItem.badgeList.length === 0)"
                             class="badge-image"
                             alt="">
                        <img v-if="!$empty(subItem.badgeList) && subItem.badgeList.length > 0"
                             :src="`${subItem.badgeList[0].imageUrl}?w=50&f=png`"
                             class="badge-image"
                             alt="" />
                        <img v-if="!$empty(subItem.badgeList) && subItem.badgeList.length > 1"
                             :src="`${subItem.badgeList[1].imageUrl}?w=50&f=png`"
                             class="badge-image badge-image--1"
                             alt="" />
                        <img v-if="!$empty(subItem.badgeList) && subItem.badgeList.length > 2"
                             :src="`${subItem.badgeList[2].imageUrl}?w=50&f=png`"
                             class="badge-image badge-image--2"
                             alt="" />
                      </div>
                      <div class="productBadgeDiv"
                           v-else-if="!$empty(subItem.badgeInfo) || (!$empty(subItem.badgeList) && subItem.badgeList.length > 0)">
                        <!-- <img :src="`${subItem.badgeInfo.imageUrl}`"
                            style="width: 30%; max-width: 100px;"
                            v-if="!$empty(subItem.badgeInfo.imageUrl)"> -->
                        <img :src="`${subItem.badgeInfo.imageUrl}`"
                             v-if="!$empty(subItem.badgeInfo.imageUrl) && ($empty(subItem.badgeList) || subItem.badgeList.length === 0)"
                             class="badge-image"
                             alt="">
                        <img v-if="!$empty(subItem.badgeList) && subItem.badgeList.length > 0"
                             :src="subItem.badgeList[0].imageUrl"
                             class="badge-image"
                             alt="" />
                        <img v-if="!$empty(subItem.badgeList) && subItem.badgeList.length > 1"
                             :src="subItem.badgeList[1].imageUrl"
                             class="badge-image badge-image--1"
                             alt="" />
                        <img v-if="!$empty(subItem.badgeList) && subItem.badgeList.length > 2"
                             :src="subItem.badgeList[2].imageUrl"
                             class="badge-image badge-image--2"
                             alt="" />
                      </div>
                      <div class="imageDivInner">
                        <img :src="`${subItem.imageUrl}${$store.state.storeSeq !== '051_00000868' ? '?w=400&f=webp&q=70' : ''}`"
                             class="productImage"
                             v-if="!$empty(subItem.imageUrl)"
                             @error="errorImage">
                        <img src="@/assets/no_item_image.png"
                             class="productImage"
                             v-else>
                      </div>
                      <div class="product-button-share__contents"
                           @click.stop="handleAddCart(subItem)"
                           v-if="!print && subItem.sell_price > 0 && $store.state.storeInfo.APP_FLAG === '1' && $store.state.storeSeq !== '051_00000501' &&
                          Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(subItem.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                        <template v-if="!checkPacking()">
                          <img src="@/assets/btn_cart2.svg"
                               style="width: 48px;"
                               v-if="!subItem.isAddCart" />
                          <img src="@/assets/btn_cart_on.svg"
                               v-else
                               alt="">
                        </template>
                        <template v-else>
                          <img src="@/assets/icon/btn_packing.svg"
                               v-if="!subItem.isAddCart" />
                          <img src="@/assets/icon/btn_packing_on.svg"
                               v-else
                               alt="">
                        </template>
                      </div>
                      <div class="product-button-share__contents"
                           @click.stop="handleAddCart(subItem)"
                           v-else-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeInfo.APP_FLAG === '1' && $store.state.storeSeq !== '051_00000501' &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img src="@/assets/icon/btn_wish.svg"
                             v-if="!subItem.isAddCart" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             v-else
                             alt="">
                      </div>
                      <div class="product-button-share__contents"
                           v-else-if="!print && subItem.sell_price > 0 && ($empty(subItem.app_price) || subItem.app_price === '' || subItem.app_price === '0') && $store.state.storeInfo.VIEW_TYPE === '2'">
                        <img src="@/assets/icon/icon_share.png"
                             class="product-button-share__icon"
                             alt=""
                             @click.stop="productShare($event, subItem, index)">
                      </div>
                    </div>
                    <div v-if="($store.state.storeInfo.APP_FLAG !== '1' || $store.state.storeSeq === '051_00000501') && $store.state.storeInfo.VIEW_TYPE !== '1'"
                         class="product-bottom"
                         :class="[{'product-bottom_3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                        {'product-bottom_4' : $store.state.storeInfo.VIEW_TYPE === '4'}]">
                      <div class="productNameDiv">
                        {{subItem.name}}
                      </div>
                      <div class="product-bottom--price"
                           v-if="subItem.sell_price > 0">
                        <span class="cost-price price__contents"
                              v-if="subItem.cost_price > 0">{{numberWithCommas(subItem.cost_price)}}</span>
                        <span class="standard price__contents">
                          {{`${!$empty(subItem.standard) && subItem.standard !== 'null' ? subItem.standard : ''}`}}</span>
                        <div v-if="!subItem.currencyUnitType || subItem.currencyUnitType === 0"
                             class="sell-price price__contents">{{numberWithCommas(subItem.sell_price)}}</div>
                        <div v-if="subItem.currencyUnitType && subItem.currencyUnitType === 1"
                             class="sell-price price__contents">{{ numberWithCommas2(subItem.sell_price) }}<span>원
                            ~</span></div>
                        <div v-if="subItem.currencyUnitType && subItem.currencyUnitType === 2"
                             class="sell-price price__contents">{{ numberWithCommas2(subItem.sell_price) }}<span>원
                            부터</span></div>
                      </div>
                      <div class="product-bottom--cart2"
                           :class="[{'product-bottom--cart3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                        {'product-bottom--cart4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                        {'product-bottom--cart0' : $store.state.storeInfo.VIEW_TYPE === '1'}]"
                           v-if="!print && subItem.sell_price > 0 &&
                        Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(subItem.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                        <img src="@/assets/icon/cart_minus.svg"
                             @click.stop="[subItem.order_qty > 0 ? subItem.order_qty-- : 0, inBasket(subItem, false)]" />
                        <span>{{  subItem.order_qty }}</span>
                        <img src="@/assets/icon/cart_plus.svg"
                             @click.stop="[subItem.order_qty++, inBasket(subItem, false)]" />
                      </div>
                      <div class="product-bottom--cart"
                           :class="[{'product-bottom--cart3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                          {'product-bottom--cart4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                          {'product-bottom--cart0' : $store.state.storeInfo.VIEW_TYPE === '1'}]"
                           @click.stop="handleAddCart(subItem)"
                           v-else-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                            $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                            $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                            $store.state.storeSeq !== '051_00000218' &&
                            $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                            $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                        <img src="@/assets/icon/btn_wish.svg"
                             v-if="!subItem.isAddCart" />
                        <img src="@/assets/icon/btn_wish_on.svg"
                             v-else
                             alt="">
                      </div>
                      <div v-else
                           class="product-bottom--cart2"
                           :class="[{'product-bottom--cart3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                        {'product-bottom--cart4' : $store.state.storeInfo.VIEW_TYPE === '4'},
                        {'product-bottom--cart0' : $store.state.storeInfo.VIEW_TYPE === '1'}]"></div>
                    </div>
                    <div v-else-if="$store.state.storeInfo.VIEW_TYPE !== '1'"
                         class="product-bottom2"
                         :class="[{'product-bottom3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                        {'product-bottom4' : $store.state.storeInfo.VIEW_TYPE === '4'}]">
                      <div class="productNameDiv2">
                        {{subItem.name}}
                      </div>
                      <div
                           :class="{'productNameDiv2': $store.state.storeSeq === '010_12345857', 'product-standard__contents': $store.state.storeSeq !== '010_12345857'}">
                        {{`${!$empty(subItem.standard) && subItem.standard !== 'null' ? subItem.standard : ''}`}}</div>
                      <div v-if="!$empty(subItem.sell_price) && Number(subItem.sell_price) > 0"
                           class="product-bottom2"
                           :class="[{'product-bottom3' : $store.state.storeInfo.VIEW_TYPE === '3'},
                          {'product-bottom4' : $store.state.storeInfo.VIEW_TYPE === '4'}]">
                        <div class="product-bottom--cost-price">
                          <!-- 정상가 -->
                          <span class="cost-price price__contents"
                                v-if="subItem.cost_price > 0">{{numberWithCommas2(subItem.cost_price)}}</span>
                          <span v-else
                                class="cost-price price__contents"
                                style="text-decoration: none;">&nbsp;</span>
                        </div>
                        <div v-if="!$empty(subItem.sell_price) && subItem.sell_price !== '' && subItem.sell_price !== '0'"
                             class="product-bottom--sell-price">
                          <!-- 행사가 -->
                          <div>전단할인가</div>
                          <div>{{numberWithCommas2(subItem.sell_price)}}</div>
                        </div>
                      </div>
                      <div v-if="!$empty(subItem.app_price) && subItem.app_price !== '' && subItem.app_price !== '0'"
                           class="product-bottom--app-price">
                        <!-- 앱특별가 -->
                        <div>앱 할인가</div>
                        <div>{{numberWithCommas2(subItem.app_price)}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="itemList"
               style="color:#666666; justify-content:center; max-height: 339px;"
               v-else>
            <div style="width:25%;height:auto;margin:auto;">
              <img src="@/assets/icon_event.png"
                   style="max-width:100px;width:100%;object-fit:contain;"
                   alt="">
            </div>
            <h2 style="color:#858585;font-size: 18px;">다음 행사 준비 중입니다.</h2>
            <div class="btnGetTeryApp"
                 @click="moveToApp">
              <span>테리문자로 행사 받기</span>
            </div>
          </div>
          <CompanyAddress v-if="!$store.state.kakao"
                          :mapData="mapData2"
                          :deliveryTimeValue="deliveryTimeValue"
                          :kakao=false />
          <div style="height: 160px;"></div>
        </div>
        <div class="content"
             v-else-if="$store.state.eventSeq === '' && selectCategory === 1">
          <div class="itemList"
               style="color:#666666; justify-content:center; max-height: 339px;">
            <div style="width:25%;height:auto;margin:auto;">
              <img src="@/assets/icon_event.png"
                   style="max-width:100px;width:100%;object-fit:contain;"
                   alt="">
            </div>
            <h2 style="color:#858585;font-size: 18px;">다음 행사 준비 중입니다.</h2>
            <div class="btnGetTeryApp"
                 @click="moveToApp">
              <span>테리문자로 행사 받기</span>
            </div>
          </div>
          <CompanyAddress v-if="!$store.state.kakao"
                          :mapData="mapData2"
                          :deliveryTimeValue="deliveryTimeValue"
                          :kakao=false />
          <div style="height: 160px;"></div>
        </div>
        <div class="content"
             v-else-if="selectCategory === 0">
          <!-- 전단행사 -->
          <div class="itemList"
               v-if="eventList.length > 0">
            <div v-for="(row, $index) in eventList"
                 :key="$index"
                 class="productItem-div">
              <div v-for="(data, index2) in row"
                   :key="index2"
                   class="product-item__wrap">
                <div class="productItem"
                     @click.stop="selectProduct(data)">
                  <div class="productImageDiv">
                    <div class="productBadgeDiv"
                         v-if="print && (!$empty(data.badgeInfo) || (!$empty(data.badgeList) && data.badgeList.length > 0))">
                      <img :src="`${data.badgeInfo.imageUrl}?w=50&f=png`"
                           v-if="!$empty(data.badgeInfo.imageUrl) && ($empty(data.badgeList) || data.badgeList.length === 0)"
                           class="badge-image"
                           alt="">
                      <img v-if="!$empty(data.badgeList) && data.badgeList.length > 0"
                           :src="`${data.badgeList[0].imageUrl}?w=50&f=png`"
                           class="badge-image"
                           alt="" />
                      <img v-if="!$empty(data.badgeList) && data.badgeList.length > 1"
                           :src="`${data.badgeList[1].imageUrl}?w=50&f=png`"
                           class="badge-image badge-image--1"
                           alt="" />
                      <img v-if="!$empty(data.badgeList) && data.badgeList.length > 2"
                           :src="`${data.badgeList[2].imageUrl}?w=50&f=png`"
                           class="badge-image badge-image--2"
                           alt="" />
                    </div>
                    <div class="productBadgeDiv"
                         v-else-if="!$empty(data.badgeInfo) || (!$empty(data.badgeList) && data.badgeList.length > 0)">
                      <!-- <img :src="`${data.badgeInfo.imageUrl}`"
                          style="width: 30%; max-width: 100px;"
                          v-if="!$empty(data.badgeInfo.imageUrl)"> -->
                      <img :src="`${data.badgeInfo.imageUrl}`"
                           v-if="!$empty(data.badgeInfo.imageUrl) && ($empty(data.badgeList) || data.badgeList.length === 0)"
                           class="badge-image"
                           alt="">
                      <img v-if="!$empty(data.badgeList) && data.badgeList.length > 0"
                           :src="data.badgeList[0].imageUrl"
                           class="badge-image"
                           alt="" />
                      <img v-if="!$empty(data.badgeList) && data.badgeList.length > 1"
                           :src="data.badgeList[1].imageUrl"
                           class="badge-image badge-image--1"
                           alt="" />
                      <img v-if="!$empty(data.badgeList) && data.badgeList.length > 2"
                           :src="data.badgeList[2].imageUrl"
                           class="badge-image badge-image--2"
                           alt="" />
                    </div>
                    <div class="imageDivInner">
                      <img :src="`${data.image_url}${$store.state.storeSeq !== '051_00000868' ? '?w=400&f=webp&q=70' : ''}`"
                           class="productImage"
                           v-if="!$empty(data.image_url)"
                           @error="errorImage">
                      <img src="@/assets/no_item_image.png"
                           class="productImage"
                           v-else>
                    </div>
                    <div class="product-button-share__contents"
                         @click.stop="handleAddCart(data)"
                         v-if="!print && data.sell_price > 0 && $store.state.storeInfo.APP_FLAG === '1' && $store.state.storeSeq !== '051_00000501' &&
                        Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(data.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                      <template v-if="!checkPacking()">
                        <img src="@/assets/btn_cart2.svg"
                             style="width: 48px;"
                             v-if="!data.isAddCart" />
                        <img src="@/assets/btn_cart_on.svg"
                             v-else
                             alt="">
                      </template>
                      <template v-else>
                        <img src="@/assets/icon/btn_packing.svg"
                             v-if="!data.isAddCart" />
                        <img src="@/assets/icon/btn_packing_on.svg"
                             v-else
                             alt="">
                      </template>
                    </div>
                    <div class="product-button-share__contents"
                         @click.stop="handleAddCart(data)"
                         v-else-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 && $store.state.storeInfo.APP_FLAG === '1' &&
                          $store.state.storeSeq !== '051_00000501' &&
                          $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                          $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                          $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                      <img src="@/assets/icon/btn_wish.svg"
                           v-if="!data.isAddCart" />
                      <img src="@/assets/icon/btn_wish_on.svg"
                           v-else
                           alt="">
                    </div>
                    <div class="product-button-share__contents"
                         v-else-if="!print && data.sell_price > 0 && ($empty(data.app_price) || data.app_price === '' || data.app_price === '0')">
                      <img src="@/assets/icon/icon_share.png"
                           class="product-button-share__icon"
                           alt=""
                           @click.stop="productShare($event, data, index2)">
                    </div>
                  </div>
                  <div v-if="$store.state.storeInfo.APP_FLAG !== '1' || $store.state.storeSeq === '051_00000501'"
                       class="product-bottom">
                    <div class="productNameDiv">
                      {{data.name}}
                    </div>
                    <div class="product-bottom--price"
                         v-if="data.sell_price > 0">
                      <span class="cost-price price__contents"
                            v-if="data.cost_price > 0">{{numberWithCommas(data.cost_price)}}</span>
                      <span class="standard price__contents">
                        {{`${!$empty(data.standard) && data.standard !== 'null' ? data.standard : ''}`}}</span>
                      <div v-if="!data.currencyUnitType || data.currencyUnitType === 0"
                           class="sell-price price__contents">{{numberWithCommas(data.sell_price)}}</div>
                      <div v-if="data.currencyUnitType && data.currencyUnitType === 1"
                           class="sell-price price__contents">{{ numberWithCommas2(data.sell_price) }}<span>원 ~</span>
                      </div>
                      <div v-if="data.currencyUnitType && data.currencyUnitType === 2"
                           class="sell-price price__contents">{{ numberWithCommas2(data.sell_price) }}<span>원 부터</span>
                      </div>
                    </div>
                    <div class="product-bottom--cart2"
                         v-if="!print && data.sell_price > 0 &&
                        Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && Number(data.status) === 2 && !isEventWait && $store.state.storeDeliveryInfo !== undefined">
                      <!-- <template v-if="!checkPacking()">
                        <img src="@/assets/btn_cart.svg"
                            v-if="!data.isAddCart" />
                        <img src="@/assets/btn_cart_on.svg"
                            v-else
                            alt="">
                      </template>
                      <template v-else>
                        <img src="@/assets/icon/btn_packing.svg"
                            v-if="!data.isAddCart" />
                        <img src="@/assets/icon/btn_packing_on.svg"
                            v-else
                            alt="">
                      </template> -->
                      <img src="@/assets/icon/cart_minus.svg"
                           @click.stop="[data.order_qty > 0 ? data.order_qty-- : 0, inBasket(data, false)]" />
                      <span>{{  data.order_qty }}</span>
                      <img src="@/assets/icon/cart_plus.svg"
                           @click.stop="[data.order_qty++, inBasket(data, false)]" />
                    </div>
                    <div class="product-bottom--cart"
                         @click.stop="handleAddCart(item)"
                         v-if="!print && Number($store.state.storeInfo.DELIVERY_FLAG) === 0 &&
                          $store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
                          $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
                          $store.state.storeSeq !== '051_00000218' &&
                          $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
                          $store.state.storeInfo.STORE_SEQ !== '051_00000992'">
                      <img src="@/assets/icon/btn_wish.svg"
                           v-if="!data.isAddCart" />
                      <img src="@/assets/icon/btn_wish_on.svg"
                           v-else
                           alt="">
                    </div>
                  </div>
                  <div v-else-if="$store.state.storeInfo.VIEW_TYPE !== '1'"
                       class="product-bottom2">
                    <div class="productNameDiv2">
                      {{data.name}}
                    </div>
                    <div
                         :class="{'productNameDiv2': $store.state.storeSeq === '010_12345857', 'product-standard__contents': $store.state.storeSeq !== '010_12345857'}">
                      {{`${!$empty(data.standard) && data.standard !== 'null' ? data.standard : ''}`}}</div>
                    <div v-if="!$empty(data.sell_price) && Number(data.sell_price) > 0"
                         class="product-bottom2">
                      <div class="product-bottom--cost-price">
                        <!-- 정상가 -->
                        <span class="cost-price price__contents"
                              v-if="data.cost_price > 0">{{numberWithCommas2(data.cost_price)}}</span>
                        <span v-else
                              class="cost-price price__contents"
                              style="text-decoration: none;">&nbsp;</span>
                      </div>
                      <div v-if="!$empty(data.sell_price) && data.sell_price !== '' && data.sell_price !== '0'"
                           class="product-bottom--sell-price">
                        <!-- 행사가 -->
                        <div>전단할인가</div>
                        <div>{{numberWithCommas2(data.sell_price)}}</div>
                      </div>
                    </div>
                    <div v-if="!$empty(data.app_price) && data.app_price !== '' && data.app_price !== '0'"
                         class="product-bottom--app-price">
                      <!-- 앱특별가 -->
                      <div>앱 할인가</div>
                      <div>{{numberWithCommas2(data.app_price)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="itemList"
               style="color:#666666; justify-content:center; max-height: 339px;"
               v-else>
            <div style="width:25%;height:auto;margin:auto;">
              <img src="@/assets/icon_event.png"
                   style="max-width:100px;width:100%;object-fit:contain;"
                   alt="">
            </div>
            <h2 style="color:#858585;font-size: 18px;">다음 행사 준비 중입니다.</h2>
            <div class="btnGetTeryApp"
                 @click="moveToApp">
              <span>테리문자로 행사 받기</span>
            </div>
          </div>
          <!-- <div class="map__wrap">
              <div class="store-map-info__container" v-if="eventProductInfo.length > 0 && eventProductInfo !== null && eventProductInfo !== undefined">
                <div class="store-map-info__contents name"><span class="store-map-info-title">매장명:</span> {{storeMapInfo.storeName}}</div>
                <div class="store-map-info__contents number"><span class="store-map-info-title">전화번호:</span> <a class="store-tel-link" :href="`tel: ${storeMapInfo.storeTel}`">{{storeMapInfo.storeTel}}</a></div>
                <div class="store-map-info__contents address"><span class="store-map-info-title">배달시간:</span> {{deliveryTimeValue}}</div>
                <div class="store-map-info__contents address"><span class="store-map-info-title">주소:</span> {{storeMapInfo.storeAddress}}</div>
              </div>
              <div class="map__container">
                <div ref="maps"></div>
              </div>
            </div> -->
          <CompanyAddress v-if="!$store.state.kakao"
                          :mapData="mapData2"
                          :deliveryTimeValue="deliveryTimeValue"
                          :kakao=false />
          <div style="height: 160px;"></div>
        </div>
        <div class="content"
             style="height: auto; display: flex; flex-direction: column;"
             v-else-if="selectCategory === 2">
          <!-- resultAlways.useFlag !== 4 -->
          <div class="old-event"
               v-if="useFlag === '1'">
            <!-- 이벤트 -->
            <div v-if="eventProductInfo.length > 0">
              <div v-for="(imageItems, $index) in eventProductInfo"
                   :key="$index">
                <img class="old-event-image"
                     :src="`${imageItems.imageUrlFull}`"
                     v-if="imageItems.imageUrlFull !== ''" />
              </div>
            </div>
            <div class="preLineBreak"
                 v-if="!$empty(guide)"
                 v-html="guide"></div>
          </div>
          <div class="point"
               v-if="useFlag === '2'">
            <!-- 포인트 -->
            <h3 style="margin: 4px">{{addPoint}}P 적립 되었습니다.</h3>
            <h3 style="margin: 4px"
                v-if="!$empty(totalPoint)">현재 포인트는 {{totalPoint}}P 입니다.</h3>
            <h3 v-if="!$empty(pointUsePossibleScore)">{{pointUsePossibleScore}}P 부터 사용 가능합니다.</h3>
          </div>
          <div class="invite"
               v-if="useFlag === '3'">
            <!-- 초대문자 -->
            <img src="@/assets/smart/btn_invitation.svg"
                 style="margin-top: 20px;"
                 @click="moveToApp" />
            <h4 style="color: #EA4E83">테리문자에서 초대장을 확인하세요.</h4>
          </div>
          <!-- <div class="map__wrap">
              <div class="store-map-info__container" v-if="eventProductInfo.length > 0 && eventProductInfo !== null && eventProductInfo !== undefined">
                <div class="store-map-info__contents name"><span class="store-map-info-title">매장명:</span> {{storeMapInfo.storeName}}</div>
                <div class="store-map-info__contents number"><span class="store-map-info-title">전화번호:</span> <a class="store-tel-link" :href="`tel: ${storeMapInfo.storeTel}`">{{storeMapInfo.storeTel}}</a></div>
                <div class="store-map-info__contents address"><span class="store-map-info-title">배달시간:</span> {{deliveryTimeValue}}</div>
                <div class="store-map-info__contents address"><span class="store-map-info-title">주소:</span> {{storeMapInfo.storeAddress}}</div>
              </div>
              <div class="map__container">
                <div ref="maps"></div>
              </div>
            </div> -->
          <CompanyAddress v-if="!$store.state.kakao"
                          :mapData="mapData2"
                          :deliveryTimeValue="deliveryTimeValue"
                          :kakao=false />
          <div style="height: 160px;"></div>
        </div>
      </div>
      <div v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
        $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
        $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
        $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000950' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000951' && $store.state.storeInfo.STORE_SEQ !== '052_00000152' &&
        $store.state.storeInfo.STORE_SEQ !== '052_00000153' && $store.state.storeInfo.STORE_SEQ !== '031_00000120' &&
        $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
           :class="['total-purchase-info__container', {show: addCart.totalCount > 0}]">
        <div class="total-price__contents">{{ addCart.totalPrice | numberOfDigits}}<span class="price-unit">원</span>
        </div>
        <div class="shopping-basket-button__contents">
          <template v-if="Number($store.state.storeInfo.DELIVERY_FLAG) !== 0">
            <button v-if="!checkPacking()"
                    type="button"
                    class="shopping-basket-button"
                    @click="basketModal()">장바구니({{addCart.totalCount}}개)</button>
            <button v-else
                    type="button"
                    class="shopping-basket-button"
                    @click="basketModal()">포장주문({{addCart.totalCount}}개)</button>
          </template>
          <template v-else>
            <button type="button"
                    class="shopping-basket-button"
                    style="background-color: #E52B72;"
                    @click="basketModal()">
              <img src="@/assets/icon/icon_wish.svg"
                   style="vertical-align: middle;" />
              <span style="vertical-align: middle;">&nbsp;찜({{addCart.totalCount}}개)</span>
            </button>
          </template>
        </div>
      </div>
      <div v-else
           :class="['total-purchase-info__container', {show: addCart.totalCount > 0}]"
           style="bottom: 50px;">
        <div class="total-price__contents">{{ addCart.totalPrice | numberOfDigits}}<span class="price-unit">원</span>
        </div>
        <div class="shopping-basket-button__contents">
          <template v-if="Number($store.state.storeInfo.DELIVERY_FLAG) !== 0">
            <button v-if="!checkPacking()"
                    type="button"
                    class="shopping-basket-button"
                    @click="basketModal()">장바구니({{addCart.totalCount}}개)</button>
            <button v-else
                    type="button"
                    class="shopping-basket-button"
                    @click="basketModal()">포장주문({{addCart.totalCount}}개)</button>
          </template>
          <template v-else>
            <button type="button"
                    class="shopping-basket-button"
                    style="background-color: #E52B72;"
                    @click="basketModal()">
              <img src="@/assets/icon/icon_wish.svg"
                   style="vertical-align: middle;" />
              <span style="vertical-align: middle;">&nbsp;찜({{addCart.totalCount}}개)</span>
            </button>
          </template>
        </div>
      </div>
      <div :class="[topBtnFlag === true && addCart.totalCount > 0 ? 'top-arrow-div-on-1' : 'top-arrow-div-off-1']"
           @click="$refs.main.scrollTo({top: 0, behavior: 'smooth'})">
        <img class="top-arrow-img"
             src="@/assets/top-arrow.png"
             alt="">
      </div>
      <div v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
        $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
        $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
        $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015' && 
        $store.state.storeInfo.STORE_SEQ !== '051_00000950' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000951' && $store.state.storeInfo.STORE_SEQ !== '052_00000152' &&
        $store.state.storeInfo.STORE_SEQ !== '052_00000153' && $store.state.storeInfo.STORE_SEQ !== '031_00000120' &&
        $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
           :class="[topBtnFlag === true && addCart.totalCount === 0 ? 'top-arrow-div-on-2' : 'top-arrow-div-off-2']"
           @click="$refs.main.scrollTo({top: 0, behavior: 'smooth'})">
        <img class="top-arrow-img"
             src="@/assets/top-arrow.png"
             alt="">
      </div>
      <div v-else
           :class="[topBtnFlag === true && addCart.totalCount === 0 ? 'top-arrow-div-on-3' : 'top-arrow-div-off-3']"
           @click="$refs.main.scrollTo({top: 0, behavior: 'smooth'})">
        <img class="top-arrow-img"
             src="@/assets/top-arrow.png"
             alt="">
      </div>
      <bottom-sheet v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
          $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
          $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
          $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
          $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
          $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
          $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015' && 
          $store.state.storeInfo.STORE_SEQ !== '051_00000950' &&
          $store.state.storeInfo.STORE_SEQ !== '051_00000951' && $store.state.storeInfo.STORE_SEQ !== '052_00000152' &&
          $store.state.storeInfo.STORE_SEQ !== '052_00000153' && $store.state.storeInfo.STORE_SEQ !== '031_00000120' &&
          $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
          $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
          $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
          $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
                    :status="true"
                    :addCart=addCart.totalCount />
      <AppChatBar v-if="$store.state.storeSeq !== '052_00000026' && $store.state.storeSeq !== '010_12345866' &&
        $store.state.storeSeq !== '051_00000440' && $store.state.storeSeq !== '052_00000088' &&
        $store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
        $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
        $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
        $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '070_00000015' && 
        $store.state.storeInfo.STORE_SEQ !== '051_00000950' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000951' && $store.state.storeInfo.STORE_SEQ !== '052_00000152' &&
        $store.state.storeInfo.STORE_SEQ !== '052_00000153' && $store.state.storeInfo.STORE_SEQ !== '031_00000120' &&
        $store.state.storeInfo.STORE_SEQ !== '166_00000015' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000994' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000993' &&
        $store.state.storeInfo.STORE_SEQ !== '051_00000992'"
                  :tel="$store.state.storeInfo.STORE_TEL" />
      <div v-if="$route.query.preview === 'true'"
           class="download"
           @click="download">이미지 다운로드</div>
    </div>

    <modal name="orderBasket"
           :width="0"
           :height="170">
      <div class="mainBasketMain">
        <br />
        <div class="mainBasketContent3">
          <span>
            주문은
          </span>
        </div>
        <div class="mainBasketContent3"
             v-if="!$empty($store.state.storeDeliveryInfo)">
          <span>
            {{ $store.state.storeDeliveryInfo.ORDER_START_TIME.substring(0, 2) }}:{{ $store.state.storeDeliveryInfo.ORDER_START_TIME.substring(2, 4) }}
            ~
            {{ $store.state.storeDeliveryInfo.ORDER_END_TIME.substring(0, 2) }}:{{ $store.state.storeDeliveryInfo.ORDER_END_TIME.substring(2, 4) }}
            까지이며,
          </span>
        </div>
        <div class="mainBasketContent3">
          <span>
            &nbsp;
          </span>
        </div>
        <div class="mainBasketContent3">
          <span>
            배달은
          </span>
        </div>
        <div class="mainBasketContent3"
             v-if="!$empty($store.state.storeDeliveryInfo)">
          <span>
            {{ $store.state.storeDeliveryInfo.DELIVERY_START_TIME.substring(0, 2) }}:{{ $store.state.storeDeliveryInfo.DELIVERY_START_TIME.substring(2, 4) }}
            ~
            {{ $store.state.storeDeliveryInfo.DELIVERY_END_TIME.substring(0, 2) }}:{{ $store.state.storeDeliveryInfo.DELIVERY_END_TIME.substring(2, 4) }}
            까지 갑니다.
          </span>
        </div>
        <br />
        <div class="mainBasketFoot">
          <div class="mainBasketBtn1"
               @click="$modal.hide('orderBasket')"></div>
          <div class="mainBasketBtn2"
               @click="[callStore(), $modal.hide('orderBasket')]">
          </div>
        </div>
      </div>
    </modal>

    <modal name="orderBasket1"
           :width="0"
           :height="130">
      <div class="mainBasketMain">
        <br />
        <div class="mainBasketContent3">
          <span>
            현재 주문 시
          </span>
        </div>
        <div class="mainBasketContent3"
             v-if="!$empty($store.state.storeDeliveryInfo)">
          <span>
            {{ $store.state.storeDeliveryInfo.DELIVERY_START_TIME.substring(0, 2) }}:{{ $store.state.storeDeliveryInfo.DELIVERY_START_TIME.substring(2, 4) }}
            ~
            {{ $store.state.storeDeliveryInfo.DELIVERY_END_TIME.substring(0, 2) }}:{{ $store.state.storeDeliveryInfo.DELIVERY_END_TIME.substring(2, 4) }}
            사이에 배달됩니다.
          </span>
        </div>
        <br />
        <div class="mainBasketFoot">
          <div class="mainBasketBtn3"
               @click="[$modal.hide('orderBasket1'), moveProductBasket()]"></div>
        </div>
      </div>
    </modal>

    <modal name="orderBasket2"
           :width="0"
           :height="130">
      <div class="mainBasketMain">
        <div class="mainBasketTitle"
             style="text-align:center;">
          <span style="margin:0;">아직 행사 중이 아닙니다.</span>
        </div>
        <div class="mainBasketContent2">
          <span>
            {{eventDate}}
          </span>
        </div>
        <div class="mainBasketFoot">
          <span class="inBasketBtn"
                @click="$modal.hide('orderBasket2')">확인</span>
        </div>
      </div>
    </modal>

    <modal name="endEventAlert"
           :width="0"
           :height="150">
      <div class="mainBasketMain">
        <div style="text-align:center;">
          <span style="margin:0;">행사기간이 종료되었습니다.</span>
          <br>
          <span style="margin:0;">매장에 문의해주세요.</span>
          <br><br>
          <a style="color: black;"
             :href="`tel: ${$store.state.storeInfo.STORE_TEL}`">전화 : {{$store.state.storeInfo.STORE_TEL}}</a>
        </div>
        <div class="mainBasketFoot">
          <!-- <span class="inBasketBtn"
                @click="[$modal.hide('endEventAlert'), allEventList.length > 0 && $store.state.storeInfo.STORE_SEQ !== '051_00000443' ? $modal.show('allEventList') : '']">확인</span> -->
          <span class="inBasketBtn"
                @click="$modal.hide('endEventAlert')">확인</span>
        </div>
      </div>
    </modal>

    <modal name="addCart"
           class="add-cart-modal"
           :width="291"
           :height="211"
           @before-open="beforeOpen">
      <div class="flex flex-column add-cart-container justify-space-between">
        <div class="counter__contents">
          <button type="button"
                  class="button minus"
                  @click="selectedItemsCount > 0 ? selectedItemsCount-- : selectedItemsCount = 0">
            <i class="fas fa-minus"></i></button>
          <div class="counter-value">{{ selectedItemsCount }}</div>
          <button type="button"
                  class="button plus"
                  @click="selectedItemsCount++"><i class="fas fa-plus"></i></button>
        </div>
        <div class="button__contents">
          <button type="button"
                  class="counter-save-button"
                  @click="[selectedItems.order_qty = selectedItemsCount, inBasket(selectedItems)]">확인</button>
        </div>
      </div>
    </modal>
    <modal name="allEventList"
           :width="'95%'"
           :height="'70%'">
      <img src="@/assets/btn_delete.png"
           class="all-event-close-btn"
           @click="$modal.hide('allEventList')" />
      <div class="all-event-container">
        <div class="all-event-head">
          <span style="font-size: 27px;">다른 행사</span>
        </div>
        <div class="all-event-body">
          <div class="all-event-content"
               v-for="(item, $index) in allEventList"
               :key="$index"
               @click="eventSeqSetting(item)">
            <div class="all-event-always"
                 v-if="item.type === 0">
              <div style="width: 100%; text-align: start;"><img src="@/assets/always_icon.png"
                     style="width: 50%; max-width: 300px;" /></div>
              <div class="all-event-count">행사상품 <span style="color: #FF4800; font-size: 24px;">{{item.count}}</span>개
              </div>
            </div>
            <div class="all-event-progress"
                 v-if="item.type === 1">
              <div class="all-event-content-top">
                <div style="width: 100%; text-align: start;"><img src="@/assets/event_progress_icon.png"
                       style="width: 40%; max-width: 300px;" /></div>
                <div class="all-event-count">행사상품 <span style="color: #E62B73; font-size: 24px;">{{item.count}}</span>개
                </div>
              </div>
              <div class="all-event-content-title">{{item.title}}</div>
              <div style="color: #E62B73; font-size: 14px;">{{item.eventDate}}</div>
            </div>
            <div class="all-event-progress"
                 v-else-if="item.type === 2">
              <div class="all-event-content-top">
                <div style="width: 100%; text-align: start;"><img src="@/assets/event_wating_icon.png"
                       style="width: 50%; max-width: 300px;" /></div>
                <div class="all-event-count">행사상품 <span style="color: #FFA842; font-size: 24px;">{{item.count}}</span>개
                </div>
              </div>
              <div class="all-event-content-title">{{item.title}}</div>
              <div style="color: #FFA842; font-size: 14px;">{{item.eventDate}}</div>
            </div>
            <div class="all-event-end"
                 v-else-if="item.type === 3">
              <div class="all-event-content-top">
                <div style="width: 100%; text-align: start;"><img src="@/assets/event_end_icon.png"
                       style="width: 50%; max-width: 300px;" /></div>
                <div class="all-event-count">행사상품 <span style="font-size: 24px;">{{item.count}}</span>개</div>
              </div>
              <div class="all-event-content-title">{{item.title}}</div>
              <div style="font-size: 14px;">{{item.eventDate}}</div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <Share class="share-component"
           v-show="showShareComponent"
           :mode="mode"
           :kakaoSendInfo="kakaoSendInfo"
           :clipboardText="clipboardText"
           @closeShareComponent="closeShareComponent" />
  </div>
</template>
<script>
// import func from './func/func.js'
import InfiniteLoading from 'vue-infinite-loading';
import { loginWithKakao } from '@/components/publicFunc/public';
import Share from '@/components/shareComponent';
import AppChatBar from '@/components/chat/AppChatBar.vue';
import CompanyAddress from '../companyAddress.vue';
import BottomSheet from './bottomSheet.vue';
import Top09 from './top09.vue';
import * as Hangul from 'hangul-js';
import html2canvas from 'html2canvas';
import Carousel from '@/components/shareComponent/Carousel.vue';
// import * as mutations from '@/graphql/mutations'
// import { API } from 'aws-amplify'
// import {mixinCheckedSeqQuery} from '@/mixins/index.js'
// import async from 'async'
export default {
  components: {
    InfiniteLoading,
    Share,
    AppChatBar,
    CompanyAddress,
    BottomSheet,
    Top09,
    Carousel,
  },
  filters: {
    costPriceFilters: (value) => {
      if (value === '0') {
        return '';
      } else {
        return value;
      }
    },
  },
  metaInfo() {
    return {
      title: `스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`,
      meta: [
        {
          vmid: 'title',
          name: 'title',
          content: `스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`,
        },
        {
          vmid: 'subject',
          name: 'subject',
          content: `${this.$store.state.storeInfo.STORE_NAME} 행사`,
        },
        {
          vmid: 'name',
          name: 'name',
          content: `스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`,
        },
        {
          vmid: 'description',
          name: 'description',
          content: `${this.$store.state.storeInfo.STORE_NAME} | 스마트전단 - 마트 행사상품을 모바일로 간편하게 확인 후 주문까지`,
        },
      ],
    };
  },
  name: 'storeMain',
  data() {
    return {
      batchSeq: '',
      searchWord: '',
      device: '',
      categoryList: [],
      onCategory: '전체',
      storeData: [],
      productCount: [],
      selectCategory: 2,
      currentPage: 0,
      popTopList: [],
      eventList: [],
      productList: [],
      // searchProductList: [],
      storeSeq: '',
      // url: '',
      maxCount: 0,
      storeInfo: {},
      state: '',
      today: Number(this.$dayjs().format('YYYYMMDD')),
      searchFlag: 0,
      size: 30,
      storeName: '',
      totalCount: 0,
      totalPage: 0,
      tmpArr: [],
      tmpEvent: [],
      tmpSearch: [],
      barcodeList: '',
      todayEndTime: this.$dayjs().format('YYYY-MM-DD 23:59:59'),
      addCart: {
        totalPrice: 0,
        totalCount: 0,
      },
      selectedItems: {},
      selectedItemsCount: 0,
      images: {
        top: [],
        middle: [],
        bottom: [],
      },
      eventProductInfo: [],
      tempEventProductInfo: [],
      selectProductCategory: '',
      storeMapInfo: {},
      showShareComponent: false,
      clipboardText: '',
      themeUrl: '',
      shortForm0: {},
      shortForm1: {},
      shortForm2: {},
      sizeup: false,
      guide: '',
      mode: 'left',
      kakaoSendInfo: {},
      popList: [],
      deviceOs: '',
      productStandardStatus: null,
      eventTitle: '',
      eventDate: null,
      isLowFirefoxVersion: false,
      backgroundHeight: 0,
      tempSubCategoryArray: [],
      tempSubCategoryList: [],
      subTitle: '',
      subTitleFlag: '0',
      topBtnFlag: false,
      isEventWait: false, // 행사대기 여부(하루전날까지 장바구니 사용가능)
      isProductBasket: true, // 주문가능 여부(행사날부터 주문 가능)
      userIndex: null,
      deliveryTimeValue: null,
      scrollY: 0,
      scrollEventY: 0,
      scrollProductY: 0,
      useFlag: '4',
      addPoint: 0,
      totalPoint: 0,
      pointUsePossibleScore: 0,
      allEventList: [],
      mapData: {},
      mapData2: {},
      eventFlag: 1, // 행사여부 0: 완료, 1: 진행, 1: 대기(예정)
      storeTime: '',
      searchKeyword: '',
      topPosition: 9,
      isWorking: false,
      print: false,
      slides: [
        {
          id: 'tery-messenger',
          image: require('@/assets/banner/220717teryMessenger002_img.png'),
          imageStyle: 'width: 100%; height: 50px; object-fit: contain',
          background: '#ff9ed0',
          clickHandler: this.moveTerysmsInstall,
          alt: '테리 메신저',
        },
        {
          id: 'sery',
          image: require('@/assets/logo/ci-sery.png'),
          imageStyle: 'object-fit: contain; width: 24px; height: 40px;',
          description: '세리에서 발송 되었습니다.',
          clickHandler: this.moveSeryTutorial,
          alt: '세리',
        },
      ],
    };
  },
  computed: {
    key: {
      get() {
        return this.$store.state.key;
      },
      set(key) {
        this.$store.commit('setKey', key);
      },
    },
    kakao: {
      get() {
        return this.$store.state.kakao;
      },
      set(kakao) {
        this.$store.commit('setKakao', kakao);
      },
    },
    appFlag: function () {
      return this.$store.state.storeInfo.APP_FLAG;
    },
  },
  created() {
    this.deviceOs = this.$cookies.get('device');
  },
  async mounted() {
    const vm = this;
    vm.$store.commit('setIsLoading', true);
    console.log('mounted :::::', vm.$options.name);
    if (!vm.$empty(localStorage.getItem(vm.key))) {
      console.log('getBasketCnt :::::', localStorage.getItem(vm.key));
      vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key));
    }
    // 카카오
    vm.kakao = vm.$route.query.kakao === 'true';
    vm.$cookies.set('nowPage', 'storeMain');
    vm.$store.state.storeSeq = vm.$_.cloneDeep(vm.$route.query.seq);
    if (vm.$route.query.seq !== null && vm.$route.query.seq !== '' && vm.$route.query.seq !== undefined) {
      vm.show();
    }

    try {
      let navUserAgent = navigator.userAgent;
      console.log('version :::::', vm.$options.name, navUserAgent);
      let browserVersion = '' + parseFloat(navigator.appVersion);
      const tempVersionOffset = navUserAgent.indexOf('Firefox');
      if (tempVersionOffset > -1 && !vm.$empty(navUserAgent)) {
        browserVersion = navUserAgent.substring(tempVersionOffset + 8);
        const versionArray = browserVersion.split('.');
        if (versionArray[0] * 1 < 65) {
          this.isLowFirefoxVersion = true;
        } else {
          this.isLowFirefoxVersion = false;
        }
      }
    } catch (e) {
      console.log('version error :::::');
    }
    try {
      console.log('배달 :::::');
      if (
        vm.$empty(vm.$store.state.storeDeliveryInfo) ||
        vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME) ||
        vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME)
      ) {
        await vm.getStoreDeliveryInfo(vm.$route.query.seq);
      }
      let startTime = vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME) ? '0000' : vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME;
      let endTime = vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME) ? '0000' : vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME;
      if (startTime === endTime) {
        vm.deliveryTimeValue = `24시간 배달`;
      } else {
        vm.deliveryTimeValue = `${startTime.substring(0, 2)}:${startTime.substring(2, 4)} ~ ${endTime.substring(0, 2)}:${endTime.substring(2, 4)}`;
      }
    } catch (e) {
      console.log('배달 error :::::');
    }
  },
  methods: {
    setKey(eventSeq) {
      console.log('setKey :::::');
      const vm = this;
      return new Promise((resolve, reject) => {
        vm.key = `${vm.$route.query.seq}_${eventSeq}`;
        resolve('success');
      });
    },
    backgroundTochStart(e) {
      console.log('backgroundTochStart :::::');
      let returnValue = -1;
      e.target.parentElement.classList.forEach((x) => {
        if (x === 'copylink' || x === 'icon__contents' || x === 'kakao') {
          returnValue = 1;
        }
      });
      this.showShareComponent = true;
      if (returnValue === -1) {
        this.showShareComponent = false;
      }
    },
    closeShareComponent() {
      this.showShareComponent = false;
    },
    async productShare(e, item, index) {
      console.log('productShare :::::');
      const vm = this;

      vm.showShareComponent = true;
      vm.mode = index % 2 === 0 ? 'left' : 'right';
      await vm.$nextTick();

      const shareComponent = document.querySelector('.share-component');
      shareComponent.style.left = index % 2 === 0 ? '-65px' : '-145px';
      shareComponent.style.top = '-90px';
      shareComponent.style.zIndex = 1;
      e.target.parentElement.append(shareComponent);
      let params = '';
      if (!vm.$empty(vm.$route.query.eventSeq)) {
        params = `seq=${vm.$route.query.seq}&eventSeq=${vm.$route.query.eventSeq}&detail=${item.barcode}`;
      } else {
        params = `seq=${vm.$route.query.seq}&detail=${item.barcode}`;
      }
      vm.clipboardText = `${window.location.origin}/detailProduct?${params}`;
      vm.kakaoSendInfo = {
        name: item.name,
        sellPrice: item.sell_price,
        imageUrl: item.image_url,
      };
    },
    changePhoneNumFormat(num) {
      console.log('changePhoneNumFormat :::::');
      const vm = this;
      let tmpNum = '';
      if (!vm.$empty(num) && num.length === 11) {
        tmpNum = num.substr(0, 3) + ' - ' + num.substr(3, 4) + ' - ' + num.substr(7, 4);
      }
      if (!vm.$empty(num) && num.length === 8) {
        tmpNum = num.substr(0, 4) + ' - ' + num.substr(4, 4);
      }
      if (!vm.$empty(num) && num.length === 10) {
        if (num.substr(0, 2) === '02') {
          tmpNum = num.substr(0, 2) + ' - ' + num.substr(2, 4) + ' - ' + num.substr(6, 4);
        } else {
          tmpNum = num.substr(0, 3) + ' - ' + num.substr(3, 3) + ' - ' + num.substr(6, 4);
        }
      }
      if (!vm.$empty(num) && num.length === 9) {
        if (num.substr(0, 2) === '02') {
          tmpNum = num.substr(0, 2) + ' - ' + num.substr(2, 3) + ' - ' + num.substr(5, 4);
        }
      }
      return tmpNum;
    },
    async getBasketInfo(targetData) {
      return new Promise((resolve, reject) => {
        const vm = this;
        console.log('getBasketInfo :::::', vm.key);
        const cartInfo = JSON.parse(localStorage.getItem(vm.key));
        let data = [];
        try {
          if (!vm.$empty(cartInfo)) {
            const newBasketInfo = [];
            for (let i = 0; i < cartInfo.length; i++) {
              let x = cartInfo[i];
              let findIndex = targetData.findIndex((y) => String(y.barcode) === String(x.barcode));
              if (findIndex === -1) {
                findIndex = targetData.findIndex((y) => y.name === x.name);
              }
              console.log('findIndex', vm.$options.name, findIndex);
              if (findIndex > -1) {
                targetData[findIndex].order_qty = x.order_qty;
                targetData[findIndex].isAddCart = true;
                newBasketInfo.push(targetData[findIndex]);
              } else {
                newBasketInfo.push(x);
              }
            }
            console.log('getBasketInfo setItem :::::', newBasketInfo);
            localStorage.setItem(vm.key, JSON.stringify(newBasketInfo));
            data = targetData;
          } else {
            data = targetData;
          }
          vm.calcTotalPrice();
          resolve(data);
        } catch (e) {
          console.log('getBasketInfo error :::::', e, vm.$options.name);
          localStorage.setItem(vm.key, '[]');
          localStorage.setItem(vm.$route.query.seq, '[]');
          resolve(targetData);
        }
      });
    },
    getSubCategoryInfo(item) {
      console.log('getSubCategoryInfo :::::');
      const vm = this;
      vm.tempSubCategoryList.forEach((items) => {
        if (item.CATEGORY_SEQ === Number(items.m_category_seq)) {
          vm.tempSubCategoryArray.push({
            categorySeq: items.categorySeq,
            eachList: items.eachList,
            level: items.level,
            m_category_seq: items.m_category_seq,
            name: items.name,
            selected: items.selected,
            subCategory: items.subCategory,
            type: items.type,
          });
          return vm.getSubCategoryInfo({
            categorySeq: items.categorySeq,
            eachList: items.eachList,
            level: items.level,
            m_category_seq: items.m_category_seq,
            name: items.name,
            selected: items.selected,
            subCategory: items.subCategory,
            type: items.type,
          });
        }
      });
      return this.tempSubCategoryArray;
    },
    setEventProductList(productList, categoryList, memoInfo, orderInfo) {
      try {
        console.log('setEventProductList :::::');
        const vm = this;
        let memo = '';
        let order = '';
        const tempCategoryList = [];
        vm.tempSubCategoryList = [];
        categoryList.map((x, index) => {
          x.subCategory = [];
          x.eachList = [];
          if (x.M_CATEGORY_SEQ === 'master') {
            if (!vm.$empty(x.CATEGORY_NAME) && x.CATEGORY_NAME.substring(0, 2) === '야채') {
              memo = unescape(vm.$empty(memoInfo.vegetableMemo) ? '' : memoInfo.vegetableMemo);
              order = vm.$empty(orderInfo.vegetable) ? 5 : orderInfo.vegetable;
            } else if (!vm.$empty(x.CATEGORY_NAME) && x.CATEGORY_NAME.substring(0, 2) === '과일') {
              memo = unescape(vm.$empty(memoInfo.fruitMemo) ? '' : memoInfo.fruitMemo);
              order = vm.$empty(orderInfo.fruit) ? 5 : orderInfo.friut;
            } else if (!vm.$empty(x.CATEGORY_NAME) && x.CATEGORY_NAME.substring(0, 2) === '정육') {
              memo = unescape(vm.$empty(memoInfo.meatMemo) ? '' : memoInfo.meatMemo);
              order = vm.$empty(orderInfo.meat) ? 5 : orderInfo.meat;
            } else if (!vm.$empty(x.CATEGORY_NAME) && x.CATEGORY_NAME.substring(0, 2) === '수산') {
              memo = unescape(vm.$empty(memoInfo.fishMemo) ? '' : memoInfo.fishMemo);
              order = vm.$empty(orderInfo.fish) ? 5 : orderInfo.fish;
            } else if (!vm.$empty(x.CATEGORY_NAME) && x.CATEGORY_NAME.substring(0, 2) === '공산') {
              memo = unescape(vm.$empty(memoInfo.memo) ? '' : memoInfo.memo);
              order = vm.$empty(orderInfo.etc) ? 5 : orderInfo.etc;
            } else {
              memo = unescape(vm.$empty(x.MEMO) ? '' : x.MEMO);
              order = index + 1;
            }
            const categoryProductData = vm.$_.sortBy(
              productList.filter((y) => y.category * 1 === x.CATEGORY_SEQ || x.CATEGORY_NAME.indexOf(y.category) > -1),
              'indexSeq'
            );
            x.MEMO = x.MEMO !== null && x.MEMO !== '' ? unescape(x.MEMO) : unescape(memo);
            x.order = !vm.$empty(x.CATEGORY_ORDER) ? x.CATEGORY_ORDER : order;
            x.eachList = categoryProductData;
            tempCategoryList.push(x);
          } else {
            const categoryProductData = vm.$_.sortBy(
              productList.filter((y) => y.category * 1 === x.CATEGORY_SEQ),
              'indexSeq'
            );
            vm.tempSubCategoryList.push({
              categorySeq: x.CATEGORY_SEQ,
              subCategory: [],
              m_category_seq: x.M_CATEGORY_SEQ,
              name: x.CATEGORY_NAME,
              level: x.LEVEL,
              type: x.M_CATEGORY_SEQ,
              eachList: categoryProductData,
            });
          }
        });
        vm.eventProductInfo = vm.$_.sortBy(tempCategoryList, 'order');
        //  최상단 액자
        vm.eventProductInfo.forEach((category) => {
          if (!vm.$empty(category.eachList)) {
            for (let i = category.eachList.length - 1; i >= 0; i--) {
              const item = category.eachList[i];
              if (!vm.$empty(item.popTop) && item.popTop.top === 1) {
                vm.popTopList.push(item);
                category.eachList.splice(i, 1);
              }
            }
          }
        });
        vm.popTopList.sort((a, b) => {
          return Number(a.popTop.topIndex) < Number(b.popTop.topIndex) ? -1 : Number(a.popTop.topIndex) > Number(b.popTop.topIndex) ? 1 : 0;
        });
        if (!vm.$empty(productList) && productList.length > 0) {
          vm.setEventSubProductList();
        } else {
          // vm.eventProductInfo = []
        }
      } catch (e) {
        console.log('setEventProductList error :::::', e);
      }
    },
    setEventSubProductList() {
      console.log('setEventSubProductList :::::');
      const vm = this;
      vm.eventProductInfo.forEach((item) => {
        item.subCategory = vm.getSubCategoryInfo(item);
        vm.tempSubCategoryArray = [];
      });
    },
    removeKakao() {
      const vm = this;
      console.log('remove kakao2 :::::', this.$refs.storeMenu);
      vm.$store.commit('setKakao', false);
      setTimeout(() => {
        vm.loadStoreMap(vm.mapData);
        if (this.$refs.storeMenu) {
          this.$refs.storeMenu.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    },
    loadStoreMap(obj) {
      const vm = this;
      console.log('loadStoreMap :::::', obj);
      if (!vm.$empty(obj)) {
        vm.mapData = vm.deepcopy(obj);
        vm.mapData2 = vm.deepcopy(obj);
      }
    },
    async getStandardStatus() {
      console.log('getStandardStatus :::::');
      const vm = this;
      const resultAlways = await vm.$axios({
        method: 'get',
        url: 'https://sery.co.kr/store/v1/' + vm.$route.query.seq + '/batchInfo',
      });
      vm.productStandardStatus = resultAlways.data.standard == null ? '' : resultAlways.data.standard;
    },
    async getEventData(obj) {
      const vm = this;
      console.log('getEventData :::::', obj);
      try {
        vm.eventProductInfo = [];
        const resultAlways = await vm.$axios.get(`${process.env.API}/smart-view-event/${vm.$route.query.seq}/${obj.eventSeq}`);
        // const resultAlways = await vm.$axios.get(`http://192.168.0.2:3005/smart-view-event/${vm.$route.query.seq}/${obj.eventSeq}`)
        console.log('resultAlways :::::', resultAlways.data.data);
        // if (resultAlways.data.status === 'fail') {
        //   // 삭제된 행사의 경우
        //   window.location.href = `https://home.tery.kr/storeMain?seq=${vm.$route.query.seq}`
        //   return
        // }
        const { storeInfo } = resultAlways.data.data;
        vm.useFlag = resultAlways.data.data.useFlag;
        vm.subTitle = resultAlways.data.data.subTitle;
        vm.subTitleFlag = resultAlways.data.data.subTitleFlag;
        setTimeout(() => {
          vm.loadStoreMap(storeInfo);
          vm.$store.state.isLoading = false;
        }, 10);
        if (vm.useFlag === '4') {
          const {
            title,
            startDate,
            endDate,
            detail,
            categoryList,
            image,
            guide,
            themeUrl,
            shortForm,
            topImageUrl,
            vegetableMemo,
            meatMemo,
            fruitMemo,
            fishMemo,
            memo,
            vegetable,
            fruit,
            meat,
            fish,
            etc,
            batchSeq,
            publicFlag,
          } = resultAlways.data.data.event;
          // console.log('publicFlag :::::', publicFlag)
          // const { imageBottom = '', imageMiddle = '', imageTop = '' } = image
          if (vm.$dayjs(endDate).format('YYYYMMDD') < vm.$dayjs().format('YYYYMMDD') || (!vm.$empty(publicFlag) && Number(publicFlag) === 0 && vm.$route.query.preview !== 'true')) {
            console.log('행사기간종료 :::::', vm.$options.name);
            vm.eventFlag = 0;
            vm.$modal.show('endEventAlert');
            vm.$store.commit('setIsLoading', false);
            return;
          }
          vm.$store.state.batchSeq = batchSeq;
          vm.eventTitle = title;
          vm.eventDate = `기간 ${vm.$dayjs(startDate).format('YYYY.MM.DD')} ~ ${vm.$dayjs(endDate).format('YYYY.MM.DD')}`;
          vm.isEventWait = false;
          const nowDate1 = vm.$dayjs().add(1, 'day').format('YYYYMMDD');
          if (vm.$dayjs(startDate).format('YYYYMMDD') > nowDate1) {
            vm.isEventWait = true;
          }
          vm.isProductBasket = true;
          const nowDate2 = vm.$dayjs().format('YYYYMMDD');
          if (vm.$dayjs(startDate).format('YYYYMMDD') > nowDate2) {
            vm.isProductBasket = false;
            vm.eventFlag = 2;
          }
          vm.eventList = resultAlways.data.data.event.detail;
          vm.themeUrl = themeUrl;
          // 미니영상
          let shortFormList = [];
          if (!vm.$empty(shortForm)) {
            shortFormList = shortForm.split('|');
          }
          console.log('shortForm :::::', shortFormList);
          for (let i = 0; i < shortFormList.length; i++) {
            if (!vm.$empty(shortFormList[i]) && shortFormList[i].indexOf('youtube') === -1) {
              const shortFormResult = await vm.$axios.get(`https://y8nuco5mt6.execute-api.ap-northeast-2.amazonaws.com/vod/${shortFormList[i]}`);
              if (!vm.$empty(shortFormResult.data) && shortFormResult.data.result === 'success') {
                if (i === 0) {
                  vm.shortForm0 = shortFormResult.data.data;
                } else if (i === 1) {
                  vm.shortForm1 = shortFormResult.data.data;
                } else if (i === 2) {
                  vm.shortForm2 = shortFormResult.data.data;
                }
              }
            } else if (!vm.$empty(shortFormList[i]) && shortFormList[i].indexOf('youtube') > -1) {
              if (vm.$store.state.storeInfo.VIEW_TYPE === '1') {
                if (i === 0) {
                  vm.shortForm0 = {
                    android1080: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&autoplay=1&mute=1',
                    android360: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&mute=1',
                    ios720: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&autoplay=1&mute=1',
                    ios360: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&mute=1',
                  };
                } else if (i === 1) {
                  vm.shortForm1 = {
                    android1080: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&autoplay=1&mute=1',
                    android360: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&mute=1',
                    ios720: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&autoplay=1&mute=1',
                    ios360: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&mute=1',
                  };
                } else if (i === 2) {
                  vm.shortForm2 = {
                    android1080: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&autoplay=1&mute=1',
                    android360: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&mute=1',
                    ios720: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&autoplay=1&mute=1',
                    ios360: vm.convertYouTubeUrl(shortFormList[i]) + '?rel=0&mute=1',
                  };
                }
              } else {
                if (i === 0) {
                  vm.shortForm0 = {
                    android1080: shortFormList[i] + '?rel=0&autoplay=1&mute=1',
                    android360: shortFormList[i] + '?rel=0&mute=1',
                    ios720: shortFormList[i] + '?rel=0&autoplay=1&mute=1',
                    ios360: shortFormList[i] + '?rel=0&mute=1',
                  };
                } else if (i === 1) {
                  vm.shortForm1 = {
                    android1080: shortFormList[i] + '?rel=0&autoplay=1&mute=1',
                    android360: shortFormList[i] + '?rel=0&mute=1',
                    ios720: shortFormList[i] + '?rel=0&autoplay=1&mute=1',
                    ios360: shortFormList[i] + '?rel=0&mute=1',
                  };
                } else if (i === 2) {
                  vm.shortForm2 = {
                    android1080: shortFormList[i] + '?rel=0&autoplay=1&mute=1',
                    android360: shortFormList[i] + '?rel=0&mute=1',
                    ios720: shortFormList[i] + '?rel=0&autoplay=1&mute=1',
                    ios360: shortFormList[i] + '?rel=0&mute=1',
                  };
                }
              }
            } else {
              if (i === 0) {
                vm.shortForm0 = {};
              } else if (i === 1) {
                vm.shortForm1 = {};
              } else if (i === 2) {
                vm.shortForm2 = {};
              }
            }
          }
          if (!vm.$empty(guide)) {
            vm.guide = guide
              .replace(
                /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g,
                '<a href="//$&" style="color: #007eb9; cursor: pointer; text-decoration: underline;">$&</a>'
              )
              .replace(/\/\/http/g, 'http');
          } else {
            vm.guide = '';
          }
          if (!vm.$empty(image)) {
            vm.images = {
              top: !vm.$empty(image.imageTop) ? image.imageTop.split('|').filter((x) => !vm.$empty(x)) : '',
              middle: !vm.$empty(image.imageMiddle) ? image.imageMiddle.split('|').filter((x) => !vm.$empty(x)) : '',
              bottom: !vm.$empty(image.imageBottom) ? image.imageBottom.split('|').filter((x) => !vm.$empty(x)) : '',
            };
          }
          if (!vm.$empty(topImageUrl)) {
            const topImageUrlArray = topImageUrl.split('|');
            vm.popList = topImageUrlArray
              .map((x) => {
                let index = detail.findIndex((y) => y.barcode === x);
                if (index > -1) {
                  // console.log('popList ::::: ', detail[index])
                  return [
                    detail[index].barcode,
                    detail[index].name,
                    detail[index].sellPrice,
                    detail[index].costPrice,
                    detail[index].standard ? detail[index].standard : '',
                    detail[index].imageUrl,
                    {
                      badgeList: !vm.$empty(detail[index].badgeInfo)
                        ? detail[index].badgeInfo
                        : !vm.$empty(detail[index].badgeList) && detail[index].badgeList.length > 0
                        ? detail[index].badgeList
                        : '',
                    },
                    detail[index].appPrice,
                  ];
                }
              })
              .filter(Boolean);

            if (vm.popList.length > 5) {
              vm.backgroundHeight = 142;
            } else if (vm.popList.length > 0 && vm.popList.length < 6) {
              vm.backgroundHeight = 122;
            }
          }
          vm.storeName = storeInfo.storeName;
          const memoInfo = {
            vegetableMemo: vegetableMemo,
            fruitMemo: fruitMemo,
            meatMemo: meatMemo,
            fishMemo: fishMemo,
            memo: memo,
          };
          const orderInfo = {
            vegetable: vegetable,
            fruit: fruit,
            meat: meat,
            fish: fish,
            etc: etc,
          };
          if (!vm.$empty(resultAlways.data.data.event.detail) && resultAlways.data.data.event.detail.length > 0) {
            resultAlways.data.data.event.detail = await setInit(resultAlways.data.data.event.detail);
          }
          // 변경된 값 검색
          const esData = await vm.getEsData(0, 200, resultAlways.data.data.event.detail, batchSeq, resultAlways.data.data.event.useFlag);
          // 장바구니 선택 표시 및 계산
          const basketItemToDetail = await vm.getBasketInfo(esData);
          vm.setEventProductList(basketItemToDetail, categoryList, memoInfo, orderInfo);
        } else if (vm.useFlag === '2') {
          // 포인트
          vm.selectCategory = 2;
          vm.addPoint = resultAlways.data.data.event.seq.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          if (!vm.$empty(resultAlways.data.data.event.totalPoint)) {
            vm.totalPoint = String(resultAlways.data.data.event.totalPoint).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          if (!vm.$empty(resultAlways.data.data.event.pointUsePossibleScore)) {
            vm.pointUsePossibleScore = String(resultAlways.data.data.event.pointUsePossibleScore).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
        } else if (vm.useFlag === '3') {
          // 초대장
          vm.selectCategory = 2;
        } else {
          // 일반문자
          vm.selectCategory = 2;
          vm.isEventWait = false;
          const json = JSON.parse(resultAlways.data.data.event);
          console.log('json :::::', json);
          vm.eventProductInfo = json.array_result[0].imageItems;
          if (json.array_result[0].useFlag === '2' || json.array_result[0].useFlag === '0') {
            // 기한종료, 삭제 이벤트
            vm.selectCategory = 1;
          } else if (json.array_result[0].useFlag === '1' || json.array_result[0].useFlag === '4') {
            if (!vm.$empty(json.array_result[0].memo)) {
              let memo = json.array_result[0].memo.replace(/\*\*스마트전단 안심클릭\*\*/gi, '');
              memo = memo.replace(/\*\*세리 스마트전단 안심클릭\*\*/gi, '');
              memo = memo.replace('tery.kr/000000<br/><br/>', '');
              vm.guide = memo.replace(/^<br\/><br\/>/, '');
            }
            // if (json.array_result[0].couponFlag === '2') {
            //   // 금액할인 쿠폰
            // } else if (json.array_result[0].couponFlag === '1') {
            //   // %할인 쿠폰
            // } else {
            //   // 상품 이벤트
            // }
          }
        }
      } catch (e) {
        console.log(e, vm.$options.name);
        // alert(e)
      }
      function setInit(data) {
        return new Promise((resolve, reject) => {
          let appTotalDiscount = 0;
          if (vm.$empty(data)) {
            return;
          }
          console.log('setInit :::::', data);
          for (let i = 0; i < data.length; i++) {
            var x = data[i];
            if (vm.$store.state.storeInfo.APP_FLAG === '1') {
              x.order_qty = 1;
            } else {
              x.order_qty = 0;
            }
            x.isAddCart = false;
            x.sell_price = x.sellPrice;
            x.cost_price = x.costPrice;
            if ((vm.$empty(x.sellPrice) || x.sellPrice === '0') && (vm.$empty(x.sell_price) || x.sell_price === '0')) {
              x.sell_price = x.costPrice;
              x.sellPrice = x.costPrice;
              x.cost_price = '';
              x.costPrice = '';
            }
            x.app_price = x.appPrice;
            // 앱할인가 총금액 계산
            if (!vm.$empty(x.appPrice)) {
              appTotalDiscount += Number(x.appPrice);
            }
            x.store_seq = x.storeSeq;
            x.like_list = [];
            x.image_url = x.imageUrl;
            x.use_flag = x.useFlag;
          }
          vm.$store.commit('setAppTotalDiscount', appTotalDiscount);
          resolve(data);
        });
      }
    },
    beforeOpen(obj) {
      this.selectedItems = obj.params.data;
      this.selectedItemsCount = obj.params.data.order_qty;
    },
    handleAddCart(data) {
      console.log('handleAddCart :::::');
      const vm = this;
      if ((data.sell_price > 0 || data.sellPrice > 0) && Number(vm.$store.state.storeInfo.DELIVERY_FLAG) !== 0) {
        // data.isAddCart = true
        vm.$modal.show('addCart', { data: data });
      } else {
        if (Number(vm.$store.state.storeInfo.DELIVERY_FLAG) !== 0) {
          alert('주문불가 상품입니다.');
        } else {
          vm.$modal.show('addCart', { data: data });
        }
      }
    },
    handleAddCart2(data) {
      console.log('handleAddCart2 :::::', this.$options.name, data);
      const vm = this;
      let size = 0;
      let index = -1;
      for (size = 0; size < vm.eventProductInfo.length; size++) {
        index = vm.eventProductInfo[size].eachList.findIndex((x) => x.barcode === data[0]);
        if (index > -1) break;
      }
      if (
        index > -1 &&
        (vm.eventProductInfo[size].eachList[index].sell_price > 0 || vm.eventProductInfo[size].eachList[index].sellPrice > 0) &&
        Number(vm.$store.state.storeInfo.DELIVERY_FLAG) !== 0
      ) {
        // data.isAddCart = true
        vm.$modal.show('addCart', { data: vm.eventProductInfo[size].eachList[index] });
      } else {
        if (Number(vm.$store.state.storeInfo.DELIVERY_FLAG) !== 0) {
          alert('주문불가 상품입니다.');
        } else {
          vm.$modal.show('addCart', { data: vm.eventProductInfo[size].eachList[index] });
        }
      }
    },
    checkBasketIcon(data) {
      console.log('checkBasketIcon :::::');
      const vm = this;
      let size = 0;
      let index = -1;
      for (size = 0; size < vm.eventProductInfo.length; size++) {
        index = vm.eventProductInfo[size].eachList.findIndex((x) => x.barcode === data[0]);
        if (index > -1) break;
      }
      return (
        index > -1 &&
        vm.eventProductInfo[size].eachList[index].sell_price > 0 &&
        Number(vm.$store.state.storeInfo.DELIVERY_FLAG) !== 0 &&
        Number(vm.eventProductInfo[size].eachList[index].status) === 2
      );
    },
    checkBasketIn(data) {
      console.log('checkBasketIn :::::');
      const vm = this;
      let size = 0;
      let index = -1;
      for (size = 0; size < vm.eventProductInfo.length; size++) {
        index = vm.eventProductInfo[size].eachList.findIndex((x) => x.barcode === data[0]);
        if (index > -1) break;
      }
      return index > -1 && !vm.eventProductInfo[size].eachList[index].isAddCart;
    },
    checkPacking() {
      console.log('checkPacking :::::');
      const vm = this;
      const storeDeliveryInfo = vm.$store.state.storeDeliveryInfo;
      if (
        !vm.$empty(storeDeliveryInfo.result) &&
        !vm.$empty(storeDeliveryInfo.result.type0) &&
        !vm.$empty(storeDeliveryInfo.result.type1) &&
        !vm.$empty(storeDeliveryInfo.result.type2) &&
        !vm.$empty(storeDeliveryInfo.result.type3) &&
        !vm.$empty(storeDeliveryInfo.result.type4) &&
        Number(storeDeliveryInfo.result.type0) === 0 &&
        Number(storeDeliveryInfo.result.type1) === 0 &&
        Number(storeDeliveryInfo.result.type2) === 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    async show() {
      console.log('show:::', this.$options.name, this.$cookies.get('mobileSelect') === 'android');
      try {
        await this.firstListCheck();
        if (this.$cookies.get('mobileSelect') === 'android') {
          this.$cookies.set('mobileSelect', 1, '5MIN');
          // this.$modal.show('mobileSelect')
        } else {
          console.log('not android:::', this.$options.name, this.$cookies.get('mobileSelect'));
        }
        setTimeout(() => {
          if (this.$refs.storeMenu) {
            this.$refs.storeMenu.scrollIntoView({ behavior: 'smooth' });
          }
        }, 200);
      } catch (e) {
        console.log('show error :::::', e);
      }
    },
    async firstListCheck() {
      console.log('firstListCheck :::::');
      // 페이지 최초 접속시 실행방법 체크
      const vm = this;
      // var second = ''
      let eventSeq = vm.$route.query.eventSeq;
      if (vm.$route.query.seq !== null && vm.$route.query.seq !== '' && vm.$route.query.seq !== undefined) {
        vm.storeInfo = await vm.firstFunc2();
      }
      if (!vm.$empty(vm.storeInfo) && Number(vm.storeInfo.DELIVERY_FLAG) === 0 && vm.$empty(vm.$cookies.get(`onlyOffline_${vm.storeInfo.STORE_SEQ}`))) {
        let nowTime = vm.$dayjs();
        var dayEndTime = vm.$dayjs(vm.todayEndTime);
        vm.$cookies.set(`onlyOffline_${vm.storeInfo.STORE_SEQ}`, 1, `${dayEndTime.diff(nowTime, 'minute')}MIN`);
        // vm.$modal.show('onlyOffline')
      }
      // 운영시간 확인
      const storeHourInfo = vm.$store.state.storeInfo.storeHourInfo;
      let startTime = '';
      let endTime = '';
      const nowTime = vm.$dayjs().format('HHmm');
      const week = vm.$dayjs().format('ddd');
      if (storeHourInfo.type === 0) {
        startTime = storeHourInfo.body[0].startDate;
        endTime = storeHourInfo.body[0].endDate;
      }
      if (storeHourInfo.type === 1) {
        if (week === '토' || week === '일') {
          startTime = storeHourInfo.body[1].startDate;
          endTime = storeHourInfo.body[1].endDate;
        } else {
          startTime = storeHourInfo.body[0].startDate;
          endTime = storeHourInfo.body[0].endDate;
        }
      }
      if (storeHourInfo.type === 2) {
        let index = -1;
        storeHourInfo.body.forEach((item) => {
          index = item.dayOfWeek.indexOf(week);
        });
        if (index > -1) {
          startTime = storeHourInfo.body[index].startDate;
          endTime = storeHourInfo.body[index].endDate;
        }
      }
      if (startTime >= nowTime && (endTime <= nowTime || endTime !== '0000')) {
        vm.storeTime = '영업전';
      } else {
        vm.storeTime = '영업중';
      }
      // 상시행사 호출
      const resultAlways = await vm.$axios.get(`https://s4fhmm88va.execute-api.ap-northeast-2.amazonaws.com/prod/batch/${vm.$route.query.seq}`);
      // const resultAlways = await vm.$axios.get(`http://192.168.0.2:3002/batch/${vm.$route.query.seq}`)
      console.log('상시 :::::', resultAlways);
      if (!vm.$empty(resultAlways.data) && !vm.$empty(resultAlways.data.sendResult) && !vm.$empty(resultAlways.data.sendResult.detail) && resultAlways.data.sendResult.detail.length > 0) {
        const eventObj = {};
        eventObj.title = '일반상품';
        eventObj.count = resultAlways.data.sendResult.detail.length;
        eventObj.eventDate = '';
        eventObj.shortUrl = resultAlways.data.sendResult.shortUrl;
        eventObj.type = 0;
        vm.allEventList.push(eventObj);
      } else {
        const eventObj = {};
        eventObj.title = '일반상품';
        eventObj.count = 0;
        eventObj.eventDate = '';
        eventObj.shortUrl = '';
        eventObj.type = 0;
        vm.allEventList.push(eventObj);
      }
      // 매장전체 행사리스트 https://sery.co.kr/store/v2/
      const resultList = await vm.$axios.get(`https://sery.co.kr/store/v2/${vm.$route.query.seq}/batch?startPuter=0&endPuter=30`);
      // const resultList = await vm.$axios.get(`http://192.168.0.2:9090/store/v2/${vm.$route.query.seq}/batch?startPuter=0&endPuter=30`)
      console.log('리스트 :::::', resultList);
      const nowDate = vm.$dayjs().format('YYYYMMDD');
      if (!vm.$empty(resultList) && resultList.data.count > 0) {
        for (let list of resultList.data.listResult) {
          const eventObj = {};
          eventObj.title = list.title;
          eventObj.count = !vm.$empty(list.detail) ? list.detail.length : 0;
          eventObj.eventDate = `${vm.$dayjs(list.startDate).format('YYYY.MM.DD')} ~ ${vm.$dayjs(list.endDate).format('YYYY.MM.DD')}(${
            vm.$dayjs(list.endDate).diff(vm.$dayjs(list.startDate), 'day') + 1
          }일간)`;
          eventObj.shortUrl = list.shortUrl;
          if (vm.$dayjs(list.startDate).format('YYYYMMDD') <= nowDate && nowDate <= vm.$dayjs(list.endDate).format('YYYYMMDD')) {
            // 행사중
            eventObj.type = 1;
          } else if (nowDate < vm.$dayjs(list.startDate).format('YYYYMMDD') && nowDate < vm.$dayjs(list.endDate).format('YYYYMMDD')) {
            // 행사대기
            eventObj.type = 2;
          } else {
            // 행사종료
            eventObj.type = 3;
          }
          if (!vm.$empty(list.publicFlag) && Number(list.publicFlag) === 1) {
            vm.allEventList.push(eventObj);
          }
        }
      }
      if (!vm.$empty(eventSeq)) {
        // 이벤트 리스트 조회
        const eventIndex = vm.allEventList.findIndex((x) => x.shortUrl.replace('tery.kr/', '') === eventSeq);
        console.log('eventIndex :::::', eventIndex);
        if (eventIndex > -1) {
          if (vm.$dayjs(vm.allEventList[eventIndex].startDate).format('YYYYMMDD') <= nowDate && nowDate <= vm.$dayjs(vm.allEventList[eventIndex].endDate).format('YYYYMMDD')) {
            // 행사 중인 이벤트인지 확인
            vm.$store.state.eventSeq = eventSeq;
            if (eventIndex === 0) {
              vm.selectCategory = 1;
            } else {
              vm.selectCategory = 0;
            }
            await vm.getEventData({ eventSeq: eventSeq });
            await vm.getStandardStatus();
            setTimeout(() => {
              document.querySelector('.main').scrollTop = vm.scrollEventY;
            }, 100);
          } else {
            // 상시행사 불러오기
            vm.selectCategory = 1;
            eventSeq = vm.allEventList[0].shortUrl.replace('tery.kr/', '');
            await vm.getEventData({ eventSeq: eventSeq });
            await vm.getStandardStatus();
            setTimeout(() => {
              document.querySelector('.main').scrollTop = vm.scrollEventY;
            }, 100);
          }
        } else {
          vm.selectCategory = 0;
          await vm.getEventData({ eventSeq: eventSeq });
          await vm.getStandardStatus();
          setTimeout(() => {
            document.querySelector('.main').scrollTop = vm.scrollEventY;
          }, 100);
        }
      } else {
        // eventSeq가 없을 때 행사리스트 중 가장 최근 행사 표시
        // 비공개 스마트전단 제외
        if (!vm.$empty(resultList) && resultList.data.count > 0) {
          for (let list of resultList.data.listResult) {
            if (
              vm.$dayjs(list.startDate).add(-1, 'd').format('YYYYMMDD') <= nowDate &&
              nowDate <= vm.$dayjs(list.endDate).format('YYYYMMDD') &&
              !vm.$empty(list.publicFlag) &&
              Number(list.publicFlag) === 1
            ) {
              eventSeq = list.shortUrl.replace('tery.kr/', '');
              console.log('eventSeq :::::', eventSeq);
              break;
            }
          }
          //  진행중인 행사가 없을 경우 일반상품장을 보여줌
          if (vm.$empty(eventSeq)) {
            // console.log('eventSeq :::::', eventSeq)
            eventSeq = vm.allEventList[0].shortUrl.replace('tery.kr/', '');
          }
        }
        vm.$store.state.eventSeq = eventSeq;
        !vm.$empty(eventSeq) && (await vm.setKey(eventSeq));
        if (!vm.$empty(eventSeq)) {
          // 가장 최근행사 불러오기
          vm.selectCategory = 0;
          await vm.getEventData({ eventSeq: eventSeq });
          await vm.getStandardStatus();
          setTimeout(() => {
            document.querySelector('.main').scrollTop = vm.scrollEventY;
          }, 100);
        } else if (!vm.$empty(resultAlways.data.sendResult.detail) && resultAlways.data.sendResult.detail.length > 0) {
          // 최근행사가 없을 경우 상시행사 불러오기
          vm.selectCategory = 1;
          eventSeq = vm.allEventList[0].shortUrl.replace('tery.kr/', '');
          await vm.getEventData({ eventSeq: eventSeq });
          await vm.getStandardStatus();
          setTimeout(() => {
            document.querySelector('.main').scrollTop = vm.scrollEventY;
          }, 100);
        } else {
          // 최근행사, 상시행사가 없을 경우
          vm.selectCategory = 1;
          const obj = {};
          obj.storeName = vm.storeInfo.STORE_NAME;
          obj.storeTel = vm.storeInfo.STORE_TEL;
          obj.storeAddress = vm.storeInfo.storeAddress;
          obj.lat = vm.storeInfo.lat;
          obj.lng = vm.storeInfo.lng;
          vm.loadStoreMap(obj);
        }
      }
      vm.$store.commit('setIsLoading', false);
    },
    async scrollFunction() {
      // console.log('scrollFunction :::::')
      // 스크롤 위치 감지하여 스크롤이 최하단일때 다음 상품 리스트 가져오기
      const vm = this;
      const eventSeq = vm.$store.state.eventSeq;
      let scrollLocation = this.$refs.main.scrollTop; // 현재 스크롤바 위치
      if (!vm.$empty(eventSeq) && vm.selectCategory === 0) {
        if (scrollLocation > 150) {
          vm.topBtnFlag = true;
        } else {
          vm.topBtnFlag = false;
        }
        return;
      }
      if (scrollLocation > 150) {
        vm.topBtnFlag = true;
      } else {
        vm.topBtnFlag = false;
      }
      let windowHeight = window.innerHeight; // 스크린 창
      let fullHeight = this.$refs.main.scrollHeight; //  margin 값은 포함 x
      if (scrollLocation + windowHeight >= fullHeight && this.onCategory === '전체') {
        this.currentPage += this.size;
        if (this.totalCount < this.currentPage) {
          console.log('마지막페이지', vm.$options.name);
          if (this.selectCategory === 0 && !this.$empty(this.tmpEvent)) {
            this.eventList.push(this.tmpEvent);
            this.tmpEvent = [];
          }
          if (this.selectCategory === 1 && !this.$empty(this.tmpArr)) {
            this.productList.push(this.tmpArr);
            this.tmpArr = [];
          }
        }
      }
    },
    async getEsData(start, size, productDetailList, batchSeq, useFlag) {
      // 검색엔진 최신 데이터 검색
      return new Promise(async (resolve, reject) => {
        console.log('getEsData :::::');
        const productList = [];
        const vm = this;
        let response = await esSearch(start, size, batchSeq, useFlag);
        const totalCount = parseInt(response.data.hits.total.value);
        productList.push(...response.data.hits.hits);
        for (let i = start + 1; i * size < totalCount; i++) {
          // console.log('for :::::', i)
          response = await esSearch(i * size, size, batchSeq, useFlag);
          productList.push(...response.data.hits.hits);
        }
        // console.log('상품 :::::', productList)
        for (let i = 0; i < productList.length; i++) {
          const data = productList[i];
          if (vm.$empty(data._source.like_list)) {
            // 좋아요 리스트가 없으면 초기화
            data._source.like_up = 0;
            data._source.like_list = [];
          }
          var firstData = await firstFunc(data._source.event_list, batchSeq, useFlag); // 행사체크
          if (!vm.$empty(firstData) && firstData.length > 0) {
            if (!vm.$empty(useFlag) && useFlag === 2) {
              //  일반상품장
              if (vm.$empty(firstData[0].name)) {
                firstData[0].name = data._source.name;
              }
              if (vm.$empty(firstData[0].standard)) {
                firstData[0].standard = data._source.standard;
              }
              if (vm.$empty(firstData[0].status) || firstData[0].status !== 0) {
                firstData[0].status = data._source.status;
              }
              if (!vm.$empty(firstData[0].index_seq) || firstData[0].index_seq === 0) {
                firstData[0].indexSeq = firstData[0].index_seq;
              }
              productDetailList.push(firstData[0]);
            } else {
              data._source.cost_price = firstData[0].cost_price;
              data._source.sell_price = firstData[0].sell_price;
              data._source.app_price = firstData[0].app_price;
              if (data._source !== 'empty' && data._source !== 'err') {
                const index = productDetailList.findIndex((x) => x.barcode === data._source.barcode);
                if (index > -1) {
                  productDetailList[index].like_list = data._source.like_list;
                  productDetailList[index].costPrice = data._source.cost_price;
                  productDetailList[index].cost_price = data._source.cost_price;
                  productDetailList[index].sellPrice = data._source.sell_price;
                  productDetailList[index].sell_price = data._source.sell_price;
                  productDetailList[index].appPrice = data._source.app_price;
                  productDetailList[index].app_price = data._source.app_price;
                }
              }
            }
          }
        }
        resolve(productDetailList);
        function esSearch(start, size, batchSeq, useFlag) {
          return new Promise(async (resolve, reject) => {
            console.log('esSearch :::::');
            var query = {
              from: start,
              size: size,
              sort: {
                modification_time: 'desc',
              },
              query: {
                bool: {
                  must: [
                    {
                      match: {
                        store_seq: vm.$route.query.seq,
                      },
                    },
                    {
                      match: {
                        'event_list.batch_seq': batchSeq,
                      },
                    },
                    {
                      match: {
                        use_flag: 1,
                      },
                    },
                    {
                      match: {
                        status: 2,
                      },
                    },
                  ],
                  must_not: [
                    {
                      match: {
                        status: 0,
                      },
                    },
                  ],
                },
              },
            };
            // if (!vm.$empty(useFlag) && useFlag === 2) {
            //   query.query.bool.must.splice(1, 1)
            //   query.query.bool.must.push({
            //     match: {
            //       'event_list.batchSeq': batchSeq
            //     }
            //   })
            // }
            const data = await vm.$axios({
              method: 'post',
              headers: {
                'content-type': 'application/json',
                Authorization: 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ=',
              },
              url: `https://es.sery.co.kr/product/_search`,
              data: JSON.stringify(query),
            });
            resolve(data);
          });
        }
        function firstFunc(val, batchSeq, useFlag) {
          // 행사 비교
          return new Promise((resolve, reject) => {
            console.log('firstFunc :::::');
            var data = vm.$_.filter(val, (x) => {
              x.appPrice = x.app_price;
              if (!vm.$empty(useFlag) && useFlag === 2) {
                if (vm.$store.state.storeInfo.APP_FLAG === '1') {
                  x.order_qty = 1;
                } else {
                  x.order_qty = 0;
                }
                x.isAddCart = false;
                if (!vm.$empty(x.sellPrice)) x.sell_price = x.sellPrice;
                else if (!vm.$empty(x.sell_price)) x.sellPrice = x.sell_price;
                if (!vm.$empty(x.costPrice)) x.cost_price = x.costPrice;
                else if (!vm.$empty(x.cost_price)) x.costPrice = x.cost_price;
                if (!vm.$empty(x.storeSeq)) x.store_seq = x.storeSeq;
                else if (!vm.$empty(x.store_seq)) x.storeSeq = x.store_seq;
                if (!vm.$empty(x.imageUrl)) x.image_url = x.imageUrl;
                else if (!vm.$empty(x.image_url)) x.imageUrl = x.image_url;
                x.like_list = [];
                if (typeof x.use_flag === 'undefined') {
                  x.use_flag = x.useFlag;
                }
                if (vm.$empty(Number(x.sell_price)) && vm.$empty(Number(x.sellPrice))) {
                  x.sell_price = !vm.$empty(x.costPrice) ? x.costPrice : vm.$empty(x.cost_price) ? '0' : x.cost_price;
                }
              }
              return (Number(x.batch_seq) === Number(batchSeq) || Number(x.batchSeq) === Number(batchSeq)) && Number(x.use_flag) === 1;
            });
            resolve(data);
          });
        }
      });
    },
    getAlwaysEventProduct(size, barcode) {
      console.log('getAlwaysEventProduct :::::');
      // 상시행사 가져오기
      const vm = this;
      var query = {
        size: size,
        // sort: {
        //   modification_time: 'desc'
        // },
        script_fields: {},
        query: {
          bool: {
            must: [
              {
                match: {
                  store_seq: vm.$route.query.seq,
                },
              },
              {
                match: {
                  use_flag: 1,
                },
              },
              {
                match: {
                  always: 1,
                },
              },
              {
                match: {
                  barcode: barcode,
                },
              },
            ],
          },
        },
      };
      vm.$axios({
        method: 'post',
        headers: {
          'content-type': 'application/json',
          Authorization: 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ=',
        },
        url: `https://es.sery.co.kr/product/_search`,
        data: JSON.stringify(query),
      }).then(async (response) => {
        // console.log('event!!')
        vm.productList = [];
        var tmpData1 = vm.$_.cloneDeep(response.data.hits.hits);
        vm.totalCount = response.data.hits.total.value;
        vm.size = size;
        vm.currentPage = size;
        vm.totalPage = 0;
        var basketProduct = JSON.parse(localStorage.getItem(vm.key));
        if (vm.$empty(tmpData1)) {
          vm.searchFlag = 1;
        } else {
          for (let i = 0; i < tmpData1.length; i++) {
            var data = tmpData1[i];
            if (vm.$empty(data._source.like_list)) {
              // 좋아요 리스트가 없으면 초기화
              data._source.like_up = 0;
              data._source.like_list = [];
            }
            var normalProductImageChk = await chkImage(data._source); // 행사중이 아닌 일반상품들의 정상적인 이미지만 분류
            if (normalProductImageChk !== 'empty' && normalProductImageChk !== 'err') {
              if (!vm.$empty(basketProduct)) {
                var index1 = basketProduct.findIndex((x) => x.barcode === data._source.barcode);
                if (index1 !== -1) {
                  data._source.isAddCart = true;
                } else {
                  data._source.isAddCart = false;
                }
              } else {
                data._source.isAddCart = false;
              }
              if (vm.$store.state.storeInfo.APP_FLAG === '1') {
                data._source.order_qty = 1;
              } else {
                data._source.order_qty = 0;
              }
              vm.tmpEvent.push(data._source);
              if (vm.tmpEvent.length === 2) {
                vm.productList.push(vm.tmpEvent);
                vm.uniqProduct(vm.productList);
                // console.log(vm.productList, 'vm.productList', vm.$options.name)
                vm.tmpEvent = [];
              }
            }
          }
        }
      });
      function chkImage(val) {
        // 이미지 변환
        return new Promise((resolve, reject) => {
          console.log('chkImage :::::');
          var imgUrl = 'https://d2nic58uh63efu.cloudfront.net';
          var imgUrl2 = 'https://product.sery.co.kr';
          if (!vm.$empty(val.image_url)) {
            if (val.image_url.indexOf(imgUrl) === -1) {
              if (val.image_url.indexOf(imgUrl2) !== -1) {
                var img1 = new Image();
                img1.src = val.image_url;
                img1.onload = () => {
                  // console.log('exist imageurl:::')
                  resolve(val);
                };
                img1.onerror = () => {
                  // console.log('err imageurl:::')
                  resolve('err');
                };
              } else if (val.image_url !== '') {
                var file = val.image_url.split(',');
                var resultAlways = `${imgUrl}/store/${file[1]}`;
                val.image_url = resultAlways;
                resolve(val);
              } else {
                resolve('empty');
              }
            } else {
              var img2 = new Image();
              img2.src = val.image_url;
              img2.onload = () => {
                // console.log('exist imageurl:::')
                resolve(val);
              };
              img2.onerror = () => {
                // console.log('err imageurl:::')
                resolve('err');
              };
            }
          } else {
            resolve('empty');
          }
        });
      }
      vm.calcTotalPrice();
    },
    async uniqProduct(val) {
      console.log('uniqProduct :::::');
      // 상품 중복제거
      // 중복상품 삭제
      // eslint-disable-next-line no-unused-vars
      const vm = this;
      var data = await flatData(val);
      var uniq = await uniqData(data);
      if (!vm.$empty(uniq)) {
      }
      function flatData(val) {
        return new Promise((resolve, reject) => {
          var data = vm.$_.flattenDeep(val);
          resolve(data);
        });
      }
      function uniqData(val) {
        return new Promise((resolve, reject) => {
          var data = vm.$_.uniqBy(val, 'barcode');
          resolve(data);
        });
      }
    },
    async operLike(oper, val) {
      // 좋아요 동작
      console.log('operLike :::::');
      if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
        this.loading = 0;
        var nowTime = this.$dayjs().unix();
        await changeLikeList(oper, nowTime, val, this.$store.state.userData);
        await calcLikeCnt(oper, val);
        // var refresh = await refreshProduct(this.product)
        if (oper === 'p') {
          if (!this.$empty(val.like_up)) {
            val.like_up += 1;
          } else {
            val.like_up = 1;
          }
          var userData = {
            time: this.$dayjs(nowTime).format('YYYYMMDDHHmmss'),
            user_seq: this.$store.state.userData.USER_SEQ,
          };
          if (!this.$empty(val.like_list)) {
            val.like_list.push(userData);
            console.log('val1:::', this.$options.name, val);
          } else {
            console.log('val2:::', this.$options.name, val.like_list);
            val.like_list.push(userData);
            console.log('val3:::', this.$options.name, val);
          }
        } else {
          if (val.like_up - 1 >= 0) {
            console.log('val4:::', this.$options.name);
            val.like_up -= 1;
            var index = val.like_list.findIndex((x) => x.user_seq === this.$store.state.userData.USER_SEQ);
            if (index !== -1) {
              val.like_list.splice(index, 1);
            }
          }
        }
      } else {
        alert('로그인이 필요한 서비스입니다.');
        loginWithKakao();
      }
      this.loading = 1;
      function changeLikeList(oper, nowTime, product, userData) {
        return new Promise((resolve, reject) => {
          console.log('changeLikeList :::::');
          var query = {};
          if (oper === 'p') {
            query = {
              script: {
                source: `if (ctx._source.like_list != null) {def targets = ctx._source.like_list.findAll(like -> like.user_seq == params.data.user_seq); if (targets.size() > 0) {for (like in targets) {like.time = params.data.time}} else {ctx._source.like_list.add(params.data)}} else {ctx._source.like_list = []; ctx._source.like_list.add(params.data)}`,
                params: {
                  data: {
                    user_seq: userData.USER_SEQ,
                    time: nowTime,
                  },
                },
                lang: `painless`,
              },
            };
          } else {
            query = {
              script: {
                source: `if (ctx._source.like_list != null) {ctx._source.like_list.removeIf(like -> like.user_seq == params.data.user_seq)}`,
                params: {
                  data: {
                    user_seq: userData.USER_SEQ,
                  },
                },
                lang: `painless`,
              },
            };
          }
          this.$axios({
            method: 'post',
            headers: {
              'content-type': 'application/json',
              Authorization: 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ=',
            },
            url: `https://es.sery.co.kr/product/_update/${product.barcode}_${product.store_seq}`,
            data: JSON.stringify(query),
          }).then((response) => {
            resolve('success1');
          });
        });
      }
      function calcLikeCnt(oper, product) {
        return new Promise((resolve, reject) => {
          console.log('calcLikeCnt :::::');
          var query = {};
          if (oper === 'p') {
            query = {
              script: {
                source: `if (ctx._source.like_up != null) {ctx._source.like_up++} else {ctx._source.like_up = 1}`,
                lang: `painless`,
              },
            };
          } else {
            query = {
              script: {
                source: `if (ctx._source.like_up != null && ctx._source.like_up > 0) {ctx._source.like_up--} else {ctx._source.like_up = 0}`,
                lang: `painless`,
              },
            };
          }
          this.$axios({
            method: 'post',
            headers: {
              'content-type': 'application/json',
              Authorization: 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ=',
            },
            url: `https://es.sery.co.kr/product/_update/${product.barcode}_${product.store_seq}`,
            data: JSON.stringify(query),
          }).then((response) => {
            resolve('success2');
          });
        });
      }
    },
    clearSearch() {
      console.log('clearSearch :::::');
      // 검색창 검색기록 지우기
      this.searchWord = '';
      document.getElementById('input-search').focus();
    },
    selectProduct(data) {
      const vm = this;
      console.log('selectProduct :::::', data);
      // 상품선택
      vm.$gtag.event('상세보기', {
        event_category: vm.$route.query.seq,
        event_label: vm.$cookies.get('userSeq'),
        value: data.name,
      });
      data.isEventWait = this.isEventWait;
      this.$store.state.selectProduct = this.$_.cloneDeep(data);
      this.moveRouter('detailProduct', false);
    },
    calcTotalPrice() {
      const vm = this;
      console.log('calcTotalPrice :::::');
      const data = JSON.parse(localStorage.getItem(vm.key));
      if (!vm.$empty(data) && data.length > 0) {
        const totalPriceArray = data.map((x) => x.sell_price * x.order_qty);
        vm.addCart.totalPrice = vm.$_.sum(totalPriceArray);
        vm.addCart.totalCount = data.reduce((acc, cur, idx) => {
          return acc + cur.order_qty;
        }, 0);
        for (let i = 0; i < vm.eventProductInfo.length; i++) {
          if (!vm.$empty(vm.eventProductInfo[i].eachList)) {
            for (let j = 0; j < vm.eventProductInfo[i].eachList.length; j++) {
              var index = data.findIndex((x) => x.barcode === vm.eventProductInfo[i].eachList[j].barcode);
              if (index > -1) {
                vm.eventProductInfo[i].eachList[j].isAddCart = true;
                vm.eventProductInfo[i].eachList[j].order_qty = data[index].order_qty;
              }
            }
          }
        }
        console.log('this1', vm.$options.name);
      } else {
        console.log('this2', vm.$options.name);
        vm.addCart.totalPrice = 0;
        vm.addCart.totalCount = 0;
      }
    },
    removeBasketItem(obj) {
      console.log('removeBasketItem :::::');
      const vm = this;
      const data = JSON.parse(localStorage.getItem(vm.key));
      if (!vm.$empty(data)) {
        const barcodeIndex = data.findIndex((x) => x.barcode === obj.barcode);
        if (barcodeIndex !== -1) {
          data.splice(barcodeIndex, 1);
          if (!vm.$empty(data) && data.length === 0) {
            localStorage.removeItem(vm.key);
            vm.$store.commit('getBasketCnt', '[]');
          } else {
            localStorage.setItem(vm.key, JSON.stringify(data));
            vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key));
          }
        }
        vm.calcTotalPrice();
      }
    },
    async inBasket(val, type = true) {
      // 장바구니 넣기
      const vm = this;
      console.log('inBasket :::::', vm.$options.name, vm.key);
      vm.$modal.hide('addCart');
      if (val.order_qty < 1) {
        vm.removeBasketItem(val);
        val.isAddCart = false;
        return;
      }
      val.isAddCart = true;
      if (vm.$empty(localStorage.getItem(vm.key))) {
        // 장바구니가 비었을때
        var data1 = [];
        if (!vm.$empty(val.store_seq)) {
          val.storeSeq = val.store_seq;
          console.log('product:::', vm.$options.name, val);
        }
        data1.push(val);
        localStorage.setItem(vm.key, JSON.stringify(data1));
        vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key));
      } else {
        // 장바구니가 비지 않았을때
        console.log('장바구니가 안빔', vm.$options.name);
        var data2 = localStorage.getItem(vm.key);
        data2 = JSON.parse(data2);
        if (!vm.$empty(val.store_seq)) {
          val.storeSeq = val.store_seq;
        }
        var barcodeIndex = data2.findIndex((x) => x.barcode === val.barcode);
        // 장바구니 담은 상품이 이미 담겨 있을때 (중복상품)
        if (barcodeIndex !== -1) {
          data2[barcodeIndex].order_qty = val.order_qty;
          vm.addCart.totalPrice += val.sell_price * data2[barcodeIndex].order_qty;
          localStorage.setItem(vm.key, JSON.stringify(data2));
          vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key));
        } else {
          data2.push(val);
          localStorage.setItem(vm.key, JSON.stringify(data2));
          vm.$store.commit('getBasketCnt', localStorage.getItem(vm.key));
        }
      }
      if (Number(vm.$store.state.storeInfo.DELIVERY_FLAG) === 0) {
        vm.$gtag.event('찜_하기', {
          event_category: vm.$route.query.seq,
          event_label: vm.$cookies.get('userSeq'),
          value: val,
        });
      } else {
        vm.$gtag.event('장바구니_담기', {
          event_category: vm.$route.query.seq,
          event_label: vm.$cookies.get('userSeq'),
          value: val,
        });
      }
      await vm.$nextTick();
      vm.calcTotalPrice();
      if (type) {
        setTimeout(() => {
          vm.$store.state.inBasket = true;
        }, 200);
        setTimeout(() => {
          vm.$store.state.inBasket = false;
        }, 700);
      }
    },
    async getCategory() {
      console.log('getCategory :::::');
      // 매장의 카테고리 정보 가져오기
      const vm = this;
      this.barcodeList = '';
      this.categoryList = await getCategoryList();
      function getCategoryList() {
        // 카테고리 리스트를 가져온다
        console.log('!!!!', vm.$options.name);
        return new Promise((resolve, reject) => {
          vm.$axios({
            method: 'get',
            headers: {
              'content-type': 'application/json',
              Authorization: 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ=',
            },
            url: `https://es.sery.co.kr/store_category/_doc/${vm.$route.query.seq}`,
          }).then((response) => {
            // console.log('category:::', vm.$options.name, response.data._source.category_list)
            var data = vm.$_.uniqBy(response.data._source.category_list, 'category');
            resolve(data);
          });
        });
      }
    },
    // async getCategoryProduct (val) {
    //   const vm = this
    //   console.log('val:::', vm.$options.name, val)
    //   this.onCategory = val
    //   if (this.selectCategory === 0) {
    //     this.eventList = []
    //   } else {
    //     this.productList = []
    //   }
    //   if (val === '전체') {
    //     if (this.selectCategory === 0) {
    //       this.eventList = []
    //       this.currentPage = 0
    //       this.getStoreEvent()
    //     } else {
    //       this.productList = []
    //       this.currentPage = 0
    //       this.getStoreProduct()
    //     }
    //   } else {
    //     var query = {
    //       from: 0,
    //       size: 10000,
    //       sort: {
    //         modification_time: 'desc'
    //       },
    //       _source: [],
    //       query: {
    //         bool: {
    //           must: [
    //             {
    //               match: {
    //                 store_seq: vm.$route.query.seq
    //               }
    //             },
    //             {
    //               match: {
    //                 use_flag: 1
    //               }
    //             },
    //             {
    //               match: {
    //                 status: 2
    //               }
    //             },
    //             {
    //               match: {
    //                 'category.category1': val
    //               }
    //             }
    //           ],
    //           must_not: [
    //             {
    //               match: {
    //                 status: 0
    //               }
    //             }
    //           ]
    //         }
    //       }
    //     }
    //     console.log('query:::', vm.$options.name, JSON.stringify(query))
    //     this.$axios({
    //       method: 'post',
    //       headers: {
    //         'content-type': 'application/json',
    //         'Authorization': 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ='
    //       },
    //       url: `https://es.sery.co.kr/product/_search`,
    //       data: JSON.stringify(query)
    //     })
    //       .then(async (response) => {
    //         var tmpData1 = vm.$_.cloneDeep(response.data.hits.hits)
    //         if (vm.$empty(tmpData1)) {
    //           console.log('empty', vm.$options.name)
    //         } else {
    //           // vm.getCategory()
    //         }
    //         for (let i = 0; i < tmpData1.length; i++) {
    //           var data = tmpData1[i]
    //           if (vm.$empty(data._source.like_list)) { // 좋아요 리스트가 없으면 초기화
    //             data._source.like_up = 0
    //             data._source.like_list = []
    //           }
    //           var firstData = await firstFunc(data._source.event_list) // 행사날짜 체크
    //           if (!vm.$empty(firstData)) {
    //             var secondData = await secondFunc(firstData) // firstData 결과에서 최저값 행사 검색 (행사가 겹칠시)
    //             data._source.sell_price = secondData.sell_price
    //             if (!vm.$empty(secondData.image_url)) {
    //               data._source.image_url = secondData.image_url
    //             }
    //             var resultData = await chkImage(data._source) // secondData 결과에서 이미지가 정상인것만 분류
    //             if (resultData !== 'empty' && resultData !== 'err') {
    //               vm.tmpArr.push(data._source)
    //               if (vm.tmpArr.length === 2) {
    //                 vm.productList.push(vm.tmpArr)
    //                 vm.uniqProduct(vm.productList)
    //                 vm.tmpArr = []
    //               }
    //             } else {
    //               // console.log('resultData:::', resultData)
    //             }
    //           } else {
    //             if (data._source.sell_price === 0 && data._source.cost_price !== 0) {
    //               // 21.07.09 0원 상품 관련으로 주석처리
    //               // data._source.sell_price = data._source.cost_price
    //             }
    //             var normalProductImageChk = await chkImage(data._source) // 행사중이 아닌 일반상품들의 정상적인 이미지만 분류
    //             if (normalProductImageChk !== 'empty' && normalProductImageChk !== 'err') {
    //               vm.tmpArr.push(data._source)
    //               if (vm.tmpArr.length === 2) {
    //                 vm.productList.push(vm.tmpArr)
    //                 vm.uniqProduct(vm.productList)
    //                 vm.tmpArr = []
    //               }
    //             } else {
    //             }
    //           }
    //         }
    //       })
    //   }
    //   function firstFunc (val) {
    //     return new Promise((resolve, reject) => {
    //       var data = vm.$_.filter(val, (x) => {
    //         return x.start_date <= vm.today && vm.today <= x.end_date
    //       })
    //       resolve(data)
    //     })
    //   }
    //   function secondFunc (val) {
    //     return new Promise((resolve, reject) => {
    //       var data = vm.$_.minBy(val, 'sell_price')
    //       resolve(data)
    //     })
    //   }
    //   function chkImage (val) {
    //     return new Promise((resolve, reject) => {
    //       var imgUrl = 'https://d2nic58uh63efu.cloudfront.net'
    //       if (!vm.$empty(val.image_url)) {
    //         if (val.image_url.indexOf(imgUrl) === -1) {
    //           resolve('empty')
    //         } else {
    //           var img = new Image()
    //           img.src = val.image_url
    //           img.onload = () => {
    //             // console.log('exist imageurl:::')
    //             resolve(val)
    //           }
    //           img.onerror = () => {
    //             // console.log('err imageurl:::')
    //             resolve('err')
    //           }
    //         }
    //       } else {
    //         resolve('empty')
    //       }
    //     })
    //   }
    // },
    numberWithCommas(x) {
      if (!x) {
        return '0원';
      } else if (x === 0 || x === '0') {
        return '0원';
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원';
      }
    },
    numberWithCommas2(x) {
      if (!x) {
        return '';
      } else if (x === 0 || x === '0') {
        return '';
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    // deliveryTime (deliveryTime) {
    //   const vm = this
    //   console.log('deliveryTime :::::')
    //   alert('배달시간', JSON.stringify(deliveryTime))
    //   let startTime = vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME) ? deliveryTime.start : vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME
    //   let endTime = vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME) ? deliveryTime.end : vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME

    //   return `${startTime.substring(0, 2)}:${startTime.substring(2, 4)} ~ ${endTime.substring(0, 2)}:${endTime.substring(2, 4)}`
    // },
    basketModal() {
      console.log('basketModal :::::');
      const vm = this;
      const nowTime = Number(vm.$dayjs().format('HHmm'));
      if (!vm.isProductBasket) {
        vm.$modal.show('orderBasket2');
        return;
      }
      if (Number(vm.$store.state.storeInfo.DELIVERY_FLAG) === 0) {
        //  찜 목록 이동
        vm.moveWishList();
      } else if (
        !vm.$empty(vm.$store.state.storeDeliveryInfo) &&
        !vm.$empty(vm.$store.state.storeDeliveryInfo.ORDER_START_TIME) &&
        !vm.$empty(vm.$store.state.storeDeliveryInfo.ORDER_END_TIME)
      ) {
        // 주문/배달가능
        const orderStartTime = vm.$store.state.storeDeliveryInfo.ORDER_START_TIME;
        const orderEndTime = vm.$store.state.storeDeliveryInfo.ORDER_END_TIME;
        const deliveryStartTime = vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME;
        const deliveryEndTime = vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME;
        if (orderStartTime === orderEndTime) {
          // 24시간
          if (deliveryStartTime > nowTime || nowTime > deliveryEndTime) {
            vm.$modal.show('orderBasket1');
          } else {
            vm.moveProductBasket();
          }
        } else if (orderStartTime < orderEndTime && orderStartTime <= nowTime && nowTime <= orderEndTime) {
          console.log('basketModal1 :::::');
          // 10:00 ~ 23:00
          if (deliveryStartTime > nowTime || nowTime > deliveryEndTime) {
            vm.$modal.show('orderBasket1');
          } else {
            vm.moveProductBasket();
          }
        } else if (orderStartTime > orderEndTime && (orderStartTime <= nowTime || nowTime <= orderEndTime)) {
          console.log('basketModal2 :::::');
          // 13:00 ~ 02:00
          if (deliveryStartTime < nowTime || nowTime > deliveryEndTime) {
            vm.$modal.show('orderBasket1');
          } else {
            vm.moveProductBasket();
          }
        } else {
          console.log('basketModal3 :::::');
          vm.$modal.show('orderBasket');
        }
      } else {
        vm.checkDeliveryTime();
      }
    },
    checkDeliveryTime() {
      console.log('checkDeliveryTime :::::');
      const vm = this;
      const nowTime = Number(vm.$dayjs().format('HHmm'));
      // 배달시간 확인
      if (
        !vm.$empty(vm.$store.state.storeDeliveryInfo) &&
        !vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME) &&
        !vm.$empty(vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME)
      ) {
        const startTime = vm.$store.state.storeDeliveryInfo.DELIVERY_START_TIME;
        const endTime = vm.$store.state.storeDeliveryInfo.DELIVERY_END_TIME;
        if (startTime === endTime) {
          // 24시간
          vm.moveProductBasket();
        } else if (startTime < endTime && startTime <= nowTime && nowTime <= endTime) {
          // 10:00 ~ 23:00
          vm.moveProductBasket();
        } else if (startTime > endTime && (startTime <= nowTime || nowTime <= endTime)) {
          // 13:00 ~ 02:00
          vm.moveProductBasket();
        } else {
          vm.$modal.show('orderBasket');
        }
      } else {
        vm.moveProductBasket();
      }
    },
    openNewTab(link) {
      this.moveRouter(link);
    },
    async eventSeqSetting(item) {
      const vm = this;
      console.log('eventSeqSetting :::::');
      const eventSeq = item.shortUrl.replace('tery.kr/', '');
      if (!vm.$empty(eventSeq) && vm.$store.state.eventSeq !== eventSeq) {
        vm.$store.state.isLoading = true;
        if (item.type === 0) {
          await callEvent(1);
        } else if (item.type === 1) {
          await callEvent(0);
        } else {
          vm.$modal.hide('allEventList');
          vm.$store.state.isLoading = false;
        }
      } else {
        vm.$modal.hide('allEventList');
      }
      async function callEvent(type) {
        console.log('callEvent :::::', type);
        vm.selectCategory = type;
        vm.$modal.hide('allEventList');
        vm.$store.state.prevEventSeq = vm.$store.state.eventSeq;
        vm.$store.state.eventSeq = eventSeq;
        await vm.getEventData({ eventSeq: eventSeq });
        await vm.getStandardStatus();
        history.pushState(
          {},
          null,
          vm.$route.path +
            '?' +
            Object.keys({ eventSeq: eventSeq })
              .map((key) => {
                return encodeURIComponent('seq') + '=' + encodeURIComponent(vm.$route.query.seq) + '&' + encodeURIComponent('eventSeq') + '=' + encodeURIComponent(eventSeq);
              })
              .join('&')
        );
        setTimeout(() => {
          document.querySelector('.main').scrollTop = vm.scrollEventY;
        }, 100);
      }
    },
    moveTerysmsInstall() {
      console.log('moveTerysmsInstall :::::');
      const vm = this;
      if (vm.$store.state.storeInfo.APP_FLAG === '1') {
        this.$gtag.event('전용앱_설치_배너_상단_선택', {
          event_category: this.$route.query.seq,
          event_label: '전용앱_설치_배너',
          value: this.$cookies.get('userSeq'),
        });
        window.open(vm.$store.state.storeInfo.APP_URL);
      } else {
        this.$gtag.event('테리문자_설치_배너_상단_선택', {
          event_category: this.$route.query.seq,
          event_label: '테리문자_설치_배너',
          value: this.$cookies.get('userSeq'),
        });
        window.open('https://tery.kr/install');
      }
    },
    moveSeryTutorial() {
      this.$gtag.event('세리_홈_배너_상단_선택', {
        event_category: this.$route.query.seq,
        event_label: '세리홈_배너',
        value: this.$cookies.get('userSeq'),
      });
      // window.open('https://sery.sery.co.kr/#/?who=smartAutoCreateShared')
      this.moveRouter('sery', false);
    },
    moveOnTeryMarket() {
      this.$gtag.event('온테리마켓_배너_상단_선택', {
        event_category: this.$route.query.seq,
        event_label: '온테리마켓_배너',
        value: this.$cookies.get('userSeq'),
      });
      window.open('https://smartstore.naver.com/tery_market/products/6532540596?utm_source=home.tery.kr&utm_medium=banner&utm_id=smart-sms-to-market');
    },
    moveProductBasket() {
      const vm = this;
      vm.$gtag.event('장바구니_이동', {
        event_category: vm.$route.query.seq,
        event_label: vm.$cookies.get('userSeq'),
        value: '',
      });
      vm.moveRouter('productBasket', false);
    },
    moveWishList() {
      const vm = this;
      vm.$gtag.event('찜_상품_이동', {
        event_category: vm.$route.query.seq,
        event_label: vm.$cookies.get('userSeq'),
        value: '',
      });
      vm.moveRouter('wishList', false);
    },
    // shortFormClick () {
    //   this.sizeup = !this.sizeup
    // },
    isWIFI() {
      console.log('isWIFI');
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || 0;
      if (!conn) {
        return -1;
      }
      if (typeof conn.type !== 'undefined') {
        switch (conn.type) {
          case 'wifi':
            return 3;
          case 'cellular':
            return 0;
          default:
            return -1;
        }
      } else if (typeof conn.saveData !== 'undefined') {
        if (conn.saveData) {
          return 1;
        } else {
          return 2;
        }
      } else {
        return -1;
      }
    },
    networkCheck() {
      console.log('networkCheck :::::');
      const vm = this;
      switch (vm.isWIFI()) {
        case -1:
        case 0:
        case 1:
          return false;
        case 2:
        case 3:
          return true;
        default:
          return false;
      }
    },
    moveRouterPath(eventSeq) {
      console.log('moveRouterPath');
      const vm = this;
      window.location.href = `${vm.$route.path}?seq=${vm.$route.query.seq}&eventSeq=${eventSeq}`;
    },
    shareLink() {
      const vm = this;
      console.log('shareLink :::::');
      const path = `https://tery.kr/${vm.$store.state.eventSeq}`;
      this.$copyText(path).then(
        function (e) {
          alert('주소가 복사되었습니다.');
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
      this.$gtag.event('알림톡_공유', {
        event_category: this.$route.query.seq,
        event_label: vm.clipboardText,
        value: '',
      });
    },
    moveChat() {
      const vm = this;
      vm.removeKakao();
      vm.moveRouter('chat');
    },
    searchChange(e) {
      const vm = this;
      vm.searchKeyword = e.target.value;
    },
    searchProduct() {
      const vm = this;
      console.log('searchProduct :::::', vm.searchKeyword);
      if (vm.searchKeyword.length > 0) {
        if (vm.tempEventProductInfo.length > 0) {
          vm.eventProductInfo = vm.$_.cloneDeep(vm.tempEventProductInfo);
        }
        vm.tempEventProductInfo = vm.$_.cloneDeep(vm.eventProductInfo);
        vm.eventProductInfo.forEach((category) => {
          category.eachList.filter((item) => Hangul.search(item.name, vm.searchKeyword) === -1).forEach((item) => category.eachList.splice(category.eachList.indexOf(item), 1));
          // category.eachList.forEach((item, index) => {
          //   if (Hangul.search(item.name, vm.searchKeyword) === -1) {
          //     category.eachList.splice(index, 1)
          //   } else {
          //     console.log(Hangul.search(item.name, vm.searchKeyword), item.name, vm.searchKeyword)
          //   }
          // })
        });
      } else {
        vm.eventProductInfo = vm.$_.cloneDeep(vm.tempEventProductInfo);
      }
      document.getElementById('body').scrollIntoView();
    },
    download() {
      const vm = this;
      if (this.isWorking) {
        alert('다운로드중입니다. 잠시만 기다려주세요.');
        return;
      }
      vm.$store.state.isLoading = true;
      vm.print = true;
      this.isWorking = true;
      const element = document.getElementById('body');
      const option = {
        proxy: 'https://image.sery.co.kr/proxy2',
        // proxy: 'http://192.168.0.2:3000/proxy2',
        scale: 1.1,
        imageTimeout: 0,
      };
      setTimeout(() => {
        html2canvas(element, option).then((canvas) => {
          const imageData = canvas.toDataURL('image/png', 1);
          const image = new Image();
          image.src = imageData;

          const link = document.createElement('a');
          link.href = imageData;
          link.download = `${vm.$dayjs().format('YYYYMMDDHHmmss')}.png`;
          link.click();

          vm.print = false;
          this.isWorking = false;
          vm.$store.state.isLoading = false;
        });
      }, 1000);
    },
    convertYouTubeUrl(url) {
      const vm = this;
      if (!vm.$empty(url)) {
        let videoId = url.includes('v=') ? url.split('v=')[1].split('&')[0] : '';
        return `https://www.youtube.com/embed/${videoId}`;
      } else {
        return '';
      }
    },
    lineBreak(text) {
      const vm = this;
      if (!vm.$empty(text)) {
        return text.split('\n');
      } else {
        return '';
      }
    },
  },
  beforeDestroy() {
    this.$refs.main.removeEventListener('scroll', (e) => {});
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.calcTotalPrice();
      console.log('beforeRouteEnter :::::', vm.scrollY, document.querySelector('.main'));
      if (document.querySelector('.main') !== null) {
        setTimeout(() => {
          document.querySelector('.main').scrollTop = vm.scrollY;
        }, 100);
      } else {
        setTimeout(() => {
          document.querySelector('.main').scrollTop = vm.scrollY;
        }, 1000);
      }
    });
  },
  // Record where you left
  beforeRouteLeave(to, from, next) {
    this.scrollY = document.querySelector('.main').scrollTop;
    console.log('Where to save the scroll bar when leaving', this.scrollY);
    next();
  },
};
</script>

<style lang="scss" scoped>
@import url('/css/main.scss');
@import '/css/top.scss';

@media (max-width: 400px) {
  .product2-detail {
    width: 100%;
    position: absolute;
  }
}

@media (min-width: 401px) and (max-width: 500px) {
  .product2-detail {
    width: 90%;
    position: absolute;
  }
}

@media (min-width: 501px) and (max-width: 600px) {
  .product2-detail {
    width: 80%;
    position: absolute;
  }
}

@media (min-width: 601px) and (max-width: 700px) {
  .product2-detail {
    width: 70%;
    position: absolute;
  }
}

@media (min-width: 701px) {
  .product2-detail {
    width: 65%;
    position: absolute;
  }
}

.selectProduct_mainImage {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  object-fit: contain;
}

.productName {
  font-size: 15px;
  color: #000000;
  color: #000;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}

.productCostPrice {
  font-size: 20px;
  color: #000000;
  text-decoration: line-through;
}

.productSellingPrice {
  display: flex;
  align-items: center;
  font-size: 30px;
  color: red;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}

.categoryTextarea {
  display: flex;
  flex-direction: column;
  background: white;
  margin: 11px 12px 0px 12px;
  gap: 10px;
  .title {
    color: #000;
    text-align: center;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .date {
    border-radius: 49px;
    background: #f00;
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 3px 29px;
  }
}

.coner-contents {
  font-family: 'ImcreSoojin';
  text-shadow: 1.5px 0px 3px #e04032, 2.5px 0px 7px #e04032, 3.5px 0px 5px #e04032, 4px 0px 4px #e04032, 3.5px -2px 4px #e04032, 2.5px -3px 2px #e04032, 3.5px 0px 9px #e04032,
    4px 0px 1.5px #e04032, 3.5px 2px 4px #e04032, 2.5px 3px 2px #e04032, 3.5px 0px 9px #e04032, 4px 0px 0px #e04032, -1.5px 0px 3px #e04032, -2.5px 0px 7px #e04032, -3.5px 0px 5px #e04032,
    -4px 0px 4px #e04032, -3.5px -2px 4px #e04032, -2.5px -3px 2px #e04032, -3.5px 0px 9px #e04032, -4px 0px 1.5px #e04032, -3.5px 2px 4px #e04032, -2.5px 3px 2px #e04032,
    -3.5px 0px 9px #e04032, -4px 0px 1.5px #e04032;
  width: 100vw;
  height: 50vw;
  min-height: 56px;
  max-height: 93px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 2px;
}

.coner-contents.background-image {
  width: 100% !important;
  height: 6rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.badge-image {
  position: relative;
  width: 30%;
  max-width: 100px;
  top: 0;
  left: 10px;
  object-fit: contain;
  &--1 {
    left: -5%;
  }
  &--2 {
    left: -15%;
  }
}

.category-container {
  position: sticky;
  top: 0px;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px 0px;
  -ms-overflow-style: none; /* 인터넷 익스플로러 */
  scrollbar-width: none; /* 파이어폭스 */
  background-color: white;
  z-index: 99;
  .border {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border: 1px #e62b73 solid;
    border-radius: 24px;
    margin: 0px 4px;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: black;
      margin: 0px 12px;
    }
  }
  .red {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e62b73;
    border-radius: 24px;
    color: white;
    padding: 0px 12px;
  }
  div {
    flex: 0 0 auto;
    height: 100%;
    .border {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      border: 1px #e62b73 solid;
      border-radius: 24px;
      margin: 0px 4px;
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: black;
        margin: 0px 12px;
      }
    }
  }
}
.category-container::-webkit-scrollbar {
  display: none;
}

.pop-top-box {
  position: relative;
  display: flex;
  width: 100%;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  background: #ffffff;
  font-family: 'Jua';
  .box__background {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .box__container {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .box__top {
      width: 53%;
      height: 100%;
      .imageDivInner {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 92%;
          object-fit: contain;
          border-radius: 20%;
          margin-top: 9vw;
          margin-left: 2vw;
        }
      }
      .productBadgeDiv {
        display: flex;
        flex-direction: row;
        gap: 5vw;
        width: 50%;
        position: absolute;
        top: 16vw;
        left: 0%;
        z-index: 1;
        img {
          width: 25%;
        }
        .badge-image--2 {
          left: -15%;
        }
      }
    }
    .box__bottom {
      position: relative;
      width: 70%;
      height: 100%;
      margin-right: 2vw;
      .top1 {
        position: absolute;
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        .name {
          width: 100%;
          height: 6vw;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-wrap: nowrap;
          overflow: hidden;
          font-weight: 700;
          font-size: 6vw;
          line-height: 1.3;
          padding-bottom: 2vw;
        }
        .standard {
          width: 100%;
          height: 6vw;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-wrap: nowrap;
          overflow: hidden;
          font-weight: 500;
          font-size: 6vw;
          line-height: 1.3;
          padding-bottom: 2vw;
        }
      }
      .top2 {
        position: absolute;
        bottom: 8%;
        width: 100%;
        height: 70%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        .name {
          width: 100%;
          height: 6vw;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          flex-wrap: nowrap;
          overflow: hidden;
          font-weight: 700;
          font-size: 6vw;
          line-height: 2;
          padding-bottom: 4vw;
        }
        .standard {
          width: 100%;
          height: 18vw;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          flex-wrap: nowrap;
          text-align: start;
          font-weight: 500;
          font-size: 5vw;
          line-height: 1;
          padding-bottom: 2vw;
        }
      }
      .bottom {
        position: absolute;
        width: 100%;
        height: 15%;
        top: 20%;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        margin-left: 2vw;
        .cost_price {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          text-decoration: line-through;
          color: #2d2d2d;
          font-weight: bold;
          font-size: 0.8rem;
        }
        div {
          position: relative;
          display: flex;
          flex-direction: column;
          .sell_price {
            width: 100%;
            position: absolute;
            top: -2vw;
            left: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            div:nth-of-type(1) {
              flex-basis: 20%;
              height: 100%;
              border-radius: 1vw;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              background-color: #ff0000;
              font-size: 2vw;
              padding-top: 1vw;
              padding-bottom: 0.5vw;
            }
            div:nth-of-type(2) {
              width: 70%;
              height: 100%;
              display: flex;
              align-items: flex-start;
              justify-content: center;
              font-weight: 600;
              font-size: 8vw;
              color: #ff0000;
              margin-left: 2vw;
            }
          }
          .app_price {
            position: absolute;
            width: 100%;
            top: 5.2vw;
            left: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            div:nth-of-type(1) {
              flex-basis: 20%;
              height: 100%;
              border-radius: 1vw;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              background-color: #1e9700;
              font-size: 2vw;
              padding-top: 1vw;
              padding-bottom: 0.5vw;
            }
            div:nth-of-type(2) {
              width: 70%;
              height: 100%;
              display: flex;
              align-items: flex-start;
              justify-content: center;
              font-weight: 600;
              font-size: 8vw;
              color: #1e9700;
              margin-left: 2vw;
            }
          }
        }
      }
      .bottom2 {
        position: absolute;
        left: 3%;
        width: 90%;
        height: 15%;
        top: 30%;
        display: flex;
        flex-direction: column;
        background-color: transparent;
        .cost_price {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-end;
          text-decoration: line-through;
          color: #2d2d2d;
          font-weight: bold;
          font-size: 0.8rem;
        }
        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .sell_price {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 100%;
            font-weight: 600;
            font-size: 8vw;
            color: #ff0000;
          }
        }
      }
      .pop-top-box--cart {
        position: absolute;
        width: 90%;
        height: 22%;
        right: 0px;
        bottom: 4px;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        background: white;
        img {
          width: 44px;
        }
        span {
          font-size: 1.8rem;
        }
      }
      .pop-top-box--cart1 {
        position: absolute;
        bottom: 4px;
        width: 85%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        img {
          width: 48px;
        }
      }
    }
  }
}

.pop-top-box-0 {
  position: relative;
  display: flex;
  width: 100%;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  background: #ffffff;
  font-family: 'Jua';
  .box__background {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .box__container {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .box__top {
      width: 100%;
      height: 100%;
      .imageDivInner {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 25%;
        img {
          width: 58%;
          object-fit: contain;
          border-radius: 20%;
        }
      }
      .productBadgeDiv {
        display: flex;
        flex-direction: row;
        gap: 5vw;
        width: 50%;
        position: absolute;
        top: 24vw;
        left: 1%;
        z-index: 1;
        img {
          width: 25%;
        }
        .badge-image--2 {
          left: -15%;
        }
      }
    }
    .box__bottom {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .top1 {
        width: 90%;
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        margin-top: 18%;
        .name {
          width: 100%;
          height: 9vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-wrap: nowrap;
          overflow: hidden;
          font-weight: 700;
          font-size: 9vw;
        }
        .standard {
          width: 100%;
          height: 9vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-wrap: nowrap;
          overflow: hidden;
          font-weight: 500;
          font-size: 9vw;
        }
      }
      .top2 {
        position: absolute;
        bottom: -16%;
        width: 90%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: transparent;
        margin-top: 1vw;
        .name {
          width: 100%;
          height: 9vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-wrap: nowrap;
          overflow: hidden;
          font-weight: 700;
          font-size: 8vw;
        }
        .standard {
          width: 100%;
          height: 25vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          flex-wrap: nowrap;
          font-weight: 500;
          font-size: 7vw;
          margin-top: 4vw;
        }
      }
      .bottom {
        position: absolute;
        top: -5%;
        width: 90%;
        height: 15%;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        align-items: center;
        .cost_price {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          text-decoration: line-through;
          color: #2d2d2d;
          font-weight: bold;
          font-size: 0.8rem;
          margin-bottom: 4%;
        }
        div {
          position: relative;
          width: 100%;
          display: flex;
          flex-direction: column;
          margin-left: 4%;
          .sell_price {
            width: 100%;
            position: absolute;
            top: -5vw;
            left: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            div:nth-of-type(1) {
              flex-basis: 16%;
              height: 100%;
              border-radius: 1vw;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              background-color: #ff0000;
              font-size: 3vw;
              padding-top: 1vw;
              padding-bottom: 0.5vw;
            }
            div:nth-of-type(2) {
              width: 70%;
              height: 100%;
              display: flex;
              align-items: flex-start;
              justify-content: center;
              font-weight: 600;
              font-size: 11vw;
              color: #ff0000;
              margin-left: 8vw;
            }
          }
          .app_price {
            position: absolute;
            width: 100%;
            top: 5.2vw;
            left: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            div:nth-of-type(1) {
              flex-basis: 16%;
              height: 100%;
              border-radius: 1vw;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              background-color: #1e9700;
              font-size: 3vw;
              padding-top: 1vw;
              padding-bottom: 0.5vw;
            }
            div:nth-of-type(2) {
              width: 70%;
              height: 100%;
              display: flex;
              align-items: flex-start;
              justify-content: center;
              font-weight: 600;
              font-size: 11vw;
              color: #1e9700;
              margin-left: 8vw;
            }
          }
        }
      }
      .bottom2 {
        position: absolute;
        top: 15%;
        left: 5%;
        width: 90%;
        height: 15%;
        display: flex;
        flex-direction: column;
        background-color: transparent;
        .cost_price {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-end;
          text-decoration: line-through;
          color: #2d2d2d;
          font-weight: bold;
          font-size: 0.8rem;
        }
        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .sell_price {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 100%;
            font-weight: 600;
            font-size: 12vw;
            color: #ff0000;
          }
        }
      }
      .pop-top-box--cart {
        position: absolute;
        width: 55%;
        height: 22%;
        right: 0px;
        bottom: 4px;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        background: white;
        img {
          width: 44px;
        }
        span {
          font-size: 1.8rem;
        }
      }
      .pop-top-box--cart1 {
        position: absolute;
        bottom: 4px;
        width: 85%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        img {
          width: 48px;
        }
      }
    }
  }
}

.download {
  position: fixed;
  bottom: 50px;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: red;
  font-weight: bold;
  background: white;
  z-index: 101;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/main/storeMain2.vue